{
  "LIST_FILTER_ROW": {
  	"aria_label": "filtres",
  	"status": "statut",
  	"open_amount": "solde ouvert",
  	"more": "+{{count}} de plus",
  	"search_tag": "chercher un tag…",
  	"or_hint": "l'un de ces tags",
  	"clear_all": "tout effacer",
  	"clear_filters": "effacer les filtres",
  	"no_results_filters": "aucune réservation avec ces filtres.",
  	"clear_chip": "effacer {{name}}",
  	"bookings_total": "{{count}} réservations",
  	"bookings_total_one": "{{count}} réservation",
  	"flights_total": "{{count}} vols",
  	"flights_total_one": "{{count}} vol",
  	"search_hint": "Entrée pour rechercher · date = aaaa-mm-jj",
  	"more_actions": "plus d'actions",
  	"period": "période",
  	"period_all": "toutes",
  	"period_today": "aujourd'hui",
  	"period_this_week": "cette semaine",
  	"period_this_month": "ce mois-ci",
  	"period_next_month": "le mois prochain",
  	"period_custom": "personnalisée…",
  	"free_spots": "places libres",
  	"free_spots_all": "toutes",
  	"free_spots_min": "au moins {{n}}",
  	"free_spots_overbooked": "surréservé"
  },
  "SEARCH_ELSEWHERE": {
    "none_in_filter": "aucun résultat dans « {{filter}} » pour « {{search}} ».",
    "found_in": "trouvé dans :",
    "also_found_in": "aussi trouvé dans"
  },
  "LOGIN": {
    "email_me_a_login_link": "envoyez-moi un lien de connexion",
    "login_link_sent": "un lien de connexion a été envoyé",
    "signed_in_elsewhere_title": "vous êtes connecté",
    "signed_in_elsewhere": "vous êtes connecté via le lien dans un autre onglet — vous pouvez fermer cet onglet",
    "continue_here": "continuer ici",
    "completing_signin": "connexion en cours…",
    "confirm_email_for_link": "veuillez confirmer votre adresse e-mail pour terminer la connexion",
    "continue": "continuer",
    "login_link_invalid": "ce lien de connexion n'est plus valide. veuillez en demander un nouveau.",
    "request_new_link": "demander un nouveau lien"
  },
  "MONTY": {
      "requested_prefix": "le client demande",
      "requested_MATCH": "{{date}} → vol {{flight}} ({{free}} libres)",
      "requested_CURRENT": "{{date}} → déjà sur ce vol ({{flight}})",
      "requested_FULL": "{{date}} → complet dans la zone",
      "requested_NOT_PLANNED": "{{date}} → pas encore de vol prévu dans la zone",
      "requested_PRIVATE_ONLY": "{{date}} → uniquement un vol privé ({{flight}})",
      "requested_OUT_OF_VALIDITY": "{{date}} → après la validité de la réservation",
      "requested_PAST": "{{date}} → dans le passé",
      "date_conflict": "le jour et la date ne correspondaient pas, la date a été utilisée",
      "needs_review": "vérifiez le texte : {{items}} ne vient pas des données de vol",
      "tag_P": "planification",
      "tag_Q": "question",
      "tag_W": "météo",
      "tag_C": "plainte / sensible",
      "tag_N": "aucune action requise",
      "action_accepted_line": "action exécutée via Monty",
    "accept": "accepter",
      "dismiss": "rejeter l'action",
      "action_repick": "cliquez pour choisir un autre vol",
      "action_CONFIRM_ON_FLIGHT": "confirmer la réservation sur",
      "action_MOVE_TO_FLIGHT": "déplacer la réservation vers",
      "action_REMOVE_FROM_FLIGHT": "retirer la réservation de",
      "failure_FLIGHT_FULL": "vol complet ou clôturé — choisissez un autre vol",
      "failure_FLIGHT_CANCELLED": "vol annulé — choisissez un autre vol",
      "failure_PROPOSAL_NOT_OPEN": "la proposition n'est plus ouverte",
      "proposal_strip": "proposition de Monty — adaptez ou envoyez",
      "proposal_clear": "supprimer la proposition",
      "proposal_insert": "proposition disponible — cliquez pour insérer",
      "settings_panel_title": "Monty - votre assistant IA",
      "settings_key_title": "clé API Anthropic",
      "settings_key_note": "Monty fonctionne sur votre propre compte Anthropic : saisissez votre clé API pour l'activer. Les coûts sont facturés sur votre compte.",
      "settings_key_label": "clé API",
      "settings_key_save": "enregistrer & valider",
      "settings_key_replace": "modifier",
      "settings_key_remove": "supprimer",
      "status_active": "actif",
      "status_no_credits": "plus de crédits — Monty est en pause",
      "status_no_credits_note": "les nouveaux messages ne sont temporairement plus étiquetés ; Monty reprend automatiquement dès que des crédits sont disponibles",
      "status_key_invalid": "clé invalide — Monty est inactif",
      "status_off": "non configuré",
      "settings_usage_title": "consommation & coûts",
      "settings_usage_note": "estimation basée sur la consommation de tokens et les prix catalogue ; la facturation passe par votre propre compte Anthropic",
      "usage_month": "mois",
      "usage_classifications": "classifications",
      "usage_proposals": "propositions",
      "usage_cost": "coût estimé",
      "usage_learn_runs": "sessions d'apprentissage",
      "instructions_title": "instructions par catégorie",
      "instructions_note": "décrivez comment vous répondez habituellement à chaque type de message (ton, infos standard, règles) — Monty s'y réfère pour rédiger ses propositions",
      "instructions_manual_label": "vos instructions",
      "instructions_learned_title": "proposition issue de l'historique — vérifiez et ajustez",
      "instructions_learned_from": "basé sur {{count}} messages répondus des {{months}} derniers mois",
      "instructions_learned_note": "Monty utilise déjà cette proposition avec vos propres instructions. Reprenez-la dans vos instructions pour la rendre définitive — sinon la prochaine session d'apprentissage la remplacera.",
      "instructions_adopt_draft": "reprendre dans mes instructions",
      "instructions_discard_draft": "supprimer la proposition",
      "instructions_save": "enregistrer",
      "learn_title": "apprendre de l'historique",
      "learn_note": "Monty étiquette vos conversations passées et distille par catégorie votre façon de répondre ; le résultat s'ajoute ci-dessus comme proposition modifiable",
      "learn_button": "apprendre de l'historique",
      "learn_month": "mois",
      "learn_months": "mois",
      "learn_messages": "messages",
      "learn_estimated_cost": "coût estimé",
      "learn_warning": "cette session consomme le crédit de votre propre compte Anthropic",
      "learn_start": "démarrer l'apprentissage",
      "learn_cancel_dialog": "annuler",
      "learn_no_messages": "aucun message sur cette période",
      "learn_progress": "{{done}} sur {{total}} messages traités",
      "learn_phase_TAGGING": "étiquetage de l'historique",
      "learn_phase_DISTILLING": "distillation des instructions",
      "learn_state_RUNNING": "session d'apprentissage en cours",
      "learn_state_COMPLETED": "session d'apprentissage terminée",
      "learn_state_CANCELLED": "session d'apprentissage annulée",
      "learn_state_STOPPED_NO_CREDITS": "arrêtée — crédit épuisé ; les étiquettes déjà posées sont conservées",
      "learn_resume": "reprendre",
      "learn_cancel_run": "annuler la session",
      "learn_cost_so_far": "consommé"
  },
  "CHARTS": {
    "last1months": "1m",
    "last3months": "3m",
    "last6months": "6m",
    "last12months": "12m",
    "last24months": "24m"
  },
  "VALIDATIONS": {
    "checkin_edit": "modifier",
    "checkin_clear_signoff": "effacer la signature",
    "checkin_clear_signoff_confirm": "Effacer la signature du pilote ? Le vol sera considéré comme non signé jusqu'à une nouvelle signature.",
    "checkin_manual_value": "défini manuellement par le pilote lors du check-in",
    "checkin_signed_off": "le vol est déjà signé - effacez d'abord la signature",
    "checkin_flight_not_found": "vol introuvable",
    "checkin_invalid_hour": "heure de décollage invalide",
    "checkin_invalid_tempTakeoff": "la température au décollage doit être comprise entre -40 et 50 °C",
    "checkin_invalid_tempBalloon": "la température du ballon doit être comprise entre 50 et 150 °C",
    "checkin_invalid_windGl": "le vent au sol doit être compris entre 0 et 60 kt",
    "checkin_invalid_windGlDirection": "la direction du vent doit être comprise entre 0 et 360°",
    "checkin_invalid_weatherQnh": "le QNH doit être compris entre 900 et 1100 hPa",
    "checkin_invalid_plannedFlightTime": "le temps de vol prévu doit être positif et ne pas dépasser le temps de vol maximal",
    "load_failed": "impossible de charger ces données",
    "error": "Erreur, controlez les données",
    "minimun_one_adult_or_Child_is_required": "Vous avez besoin d'au moins un adulte ou un enfant",
    "error_tenant_does_not_exist": "l'opérateur n'existe pas",
    "not_possible": "cette action n'est pas possible",
    "required": "champ obligatoire",
    "tenant_is_required": "opérateur est un champ obligatoire",
    "email_is_required": "email est un champ obligatoire",
    "wrong_password": "wrong password",
    "check_email": "a password reset link was sent",
    "International_phone_format": "format international expecté",
    "email": "email n'est pas valide",
    "duplicate_email": "adresse email dupliquée, action non valide",
    "no_integer": "ce n’est pas un nombre entier valide",
    "positive_number": "doit être zéro ou positif",
    "lift_orange_below_red": "la limite verte doit être au moins égale à la limite orange",
    "token_has_expired": "votre session est écoulée",
    "wrong_credentials": "identifiant non reconnu",
    "flight_date_in_past": "ce vol est dans le passé",
    "save_or_cancel_updates": "enregistrez ou annulez tes changements",
    "warning": "attention",
    "capacity_must_be_between_0_and_30": "la capacité doit être entre 0 et 100",
    "validation_errors": "corrigez d'abord les erreurs",
    "mismatch_location": "la base de vol ne situe pas dans la région de la réservation",
    "mismatch_availability": "temps de vol ne correspond pas avec la disponibilité de la réservation",
    "mismatch_start_date": "date de vol est plus tôt que le date de début de la réservation",
    "mismatch_end_date": "date de vol est plus tard que le date de fin de la réservation",
    "mismatch_type": "type de vol ne correspond pas avec le type de la réservation",
    "mismatch_flight": "ajouté à un autre vol",
    "missing_function": "cette fonction n'existe pas encore",
    "attachment_not_found": "fichier introuvable dans le stockage",
    "invalid_file_only_pdf_jpg_png_max_10MB": "Fichier invalide : seuls les fichiers PDF, JPG et PNG jusqu'à 10 Mo sont acceptés.",
    "invalid_file_too_large_max_10MB": "Le fichier est trop volumineux : la taille maximale est de 10 Mo.",
    "no_category": "pas de categories passagers trouvées, ajoutez 1 ou plusieures catégories dans vos préférences.",
    "no_region": "pas de région trouvé, ajoutez d'abord 1 ou plusieurs régions.",
    "lift_mismatch": "pas possible de calculer le lift et ce dû à un manque de données",
    "lift_missing_location": "donnée endroit de décollage manquant",
    "lift_missing_balloon_volume": "donnée volume du ballon manquant",
    "lift_missing_balloon_weight": "donnée poids du ballon manquant ou incomplet",
    "lift_missing_pilot": "donnée pilote inconnu/manquant",
    "lift_missing_pilot_weight": "donnée poids du pilote inconnu/manquant",
    "lift_missing_temp_takeoff": "donnée température au décollage manquante",
    "lift_missing_pressure": "donnée pression au point de décollage manquante",
    "mobile_missing_signature": "tous les passagers ne sont pas enregistrés/manque signature",
    "mobile_missing_forecast": "données météo manquantes",
    "mobile_documents": "dates de validité",
    "mobile_doc_insurance": "assurance valide jusqu'à",
    "mobile_doc_airworthiness": "certificat de navigabilité valide jusqu'au",
    "mobile_doc_license": "license de pilot valide jusqu'à",
    "mobile_clear": "effacer",
    "mobile_agree": "sauvegarder",
    "mobile_self_sign": "signer X",
    "click_to_fly": "cliquez ici pour voler",
    "click_to_fly_all": "confimer tous",
    "pax_good_to_fly": "pax ok",
    "lift_good_to_fly": "lift ok",
    "fuel_good_to_fly": "fuel ok",
    "weather_good_to_fly": "météo ok",
    "docs_good_to_fly": "documents ok",
    "pilot_sign_off": "confirmez tous les paramètres et signez. Des commentaires peuvent être ajouter.",
    "agree": "pour accord",
    "redo": "éffacer",
    "new_version": "nouvelle version disponible",
    "reload_the_app": "désirez vous redémarrez Quick Release maintenant ?",
    "new_features_available": "{0} nouvelles fonctionnalités disponibles",
    "show_new_features": "montrer les nouvelles fonctionnalités",
    "forget_device": "déconnexion et oublie le device",
    "bookings_with_open_amount": "réservations avec solde dû",
    "bookings_to_confirm": "à confirmer",
    "bookings_bookmarked": "marquées",
    "cylinder_capacity_must_be_between_0_and_200": "la capacité doit être entre 0 et 200",
    "cylinder_weight_must_be_between_0_and_200": "le poids doit être entre 0 et 200",
    "unauthorized": "vous n'êtes pas authorizé pour cette opération",
    "disconnected": "problème avec la connection, connectez-vous à l'internet",
    "possible_duplicates": "attention, réservation double possible, nous avons trouvé une réservation ouverte avec les mêmes coordonnées",
    "possible_duplicates_with_flights": "attention, réservation double possible sur un autre vol",
    "duplicate_flight": "ballon déjà planifié",
    "duplicate_pilot": "pilote déjà planifié",
    "crew_ready_changed_warning": "L'équipage a déjà été informé. Veuillez les prévenir des modifications."
  },
  "HINTS": {
    "add_country_code": "ajouter le code international du pays +32...",
    "no_contact_selected": "pas de donnée de contact sélectionnée",
    "message_filter": "filtre on/off",
    "role_can_only_be_set_after_creation": "le role ne peut être sélectionner après la création",
    "please_wait": "patience s.v.p."
  },
  "SKEYES": {
    "ballooning_bulletin": "Ballooning Bulletin",
    "load": "Skeyes login",
    "disclaimer": "Ballooning Bulleting est un service de Skeyes.",
    "instructions": "Entrez votre login et mot de passe Skeyes pour consulter le Ballooning Bulletin. Seuls les pilotes avec une licence valide peuvent consulter le Ballooning Bulletin. Les données sont uniquement utilisées pour consulter le Ballooning Bulletin et ne sont pas enregistrées. Les conditions d'utilisation de Skeyes s'appliquent.",
    "username": "Skeyes Username",
    "password": "Skeyes Password",
    "loaded_by": "Chargé par",
    "loading_can_take_up_to_15sec": "Chargement peut prendre jusqu'à 15 secondes",
    "error": "erreur inattendue, vérifiez tous les champs",
    "slot_warning": "ce bulletin n'est peut-être pas applicable pour ce vol"
  },
  "APPLICATION": {
    "domain": "domaine",
    "Du": "nederlands (Nederland)",
    "Nl": "nederlands (België)",
    "Fr": "français",
    "En": "anglais (english)",
    "Es": "español (spanish)",
    "Cs": "cesky (czech)",
    "It": "Italiano (Italian)",
    "De": "Deutsch (German)",
    "Pt": "Português (portuguese)",
    "Lv": "Latviešu (Latvian)",
    "date": "date",
    "name": "nom d'utilisateur",
    "call_sign": "immatriculation",
    "capacity": "capacité",
    "flight_count": "vols",
    "sku": "sku",
    "unit_count": "nombre",
    "unit_cost": "prix unitaire",
    "send_sms": "sms envoyés",
    "receive_sms": "sms reçus",
    "sms_count": "sms",
    "payments": "paiements",
    "running_month": "mois en cours",
    "history_balloons": "historique ballons",
    "history_sms": "histoirique sms",
    "total_cost": "prix",
    "sorry": "excuses",
    "flights": "vols",
    "calendar": "calendrier",
    "vouchers": "bons cadeau",
    "bookings": "réservations",
    "balloons": "ballons",
    "crew": "crew et pilotes",
    "regions": "régions",
    "locations": "bases de décollage",
    "reports": "rapports",
    "logbooks": "carnets de vol",
    "admin": "gestion",
    "releasenotes": "release notes",
    "subscription": "abonnement",
    "log_sms_in": "sms entrant",
    "log_sms_out": "sms sortant",
    "settings": "préférences",
    "cylinders": "cylinders",
    "language": "langue",
    "sms": "sms",
    "help": "aide",
    "search": "chercher",
    "live_filter_off": "Utilisez le bouton de recherche pour rechercher. Si plus de 25 résultats de recherche doivent être affichés, la recherche en direct n’est pas possible",
    "add_booking": "ajouter réservation",
    "add_voucher": "ajouter un bon",
    "add_flight": "ajouter un vol",
    "privacy_policy": "politique de confidentialité",
    "terms": "conditions d'utilisation",
    "sign in to use your Quick Release Account": "Identifiez-vous",
    "your username and password didn't match": "votre nom d'utilisateur et mot de passe ne correspondent pas",
    "please try again": "veuillez réessayer",
    "username": "nom d'utilisateur",
    "password": "mot de passe",
    "sign_in": "connexion",
    "send_PIN": "envoyer PIN",
    "use_PIN": "accorder PIN",
    "pin_successfully_sent": "PIN envoyé avec succès",
    "use_password": "password",
    "send_email": "envoyer email",
    "email": "email",
    "send_email_to": "sélectionner le destinataire",
    "select_template": "sélectionner template",
    "sent": "envoyé le",
    "waiting": "en cours de transmission",
    "error": "échec de l'envoi",
    "pin": "PIN",
    "verification_code": "Code de vérification",
    "verification_code_subtitle": "Veuillez entrer le code de vérification que vous avez reçu par email",
    "resend_code": "renvoyer le code",
    "resend_code_disabled": "renvoyer le code dans 30 secondes",
    "code_required": "Le code est requis",
    "code_pattern": "Doit être 6 chiffres",
    "verify_code": "vérifier le code",
    "trust_device": "Cet appareil sera considéré comme fiable pendant 60 jours. Au cours des 60 prochains jours, aucun code de vérification ne sera nécessaire pour vous connecter.",
    "sign_out": "déconnexion",
    "save": "enregistrer",
    "save_and_back": "enregistrer et retourner",
    "cancel": "annuler",
    "previous": "précédente",
    "delete": "supprimer",
    "refresh": "renouveller",
    "new_version_available": "une nouvelle version de Quick Release est disponible",
    "today": "aujourd'hui",
    "classic": "interface classique",
    "month": "mois",
    "week": "semaine",
    "morning_flights": "vols ce matin",
    "evening_flights": "vols ce soir",
    "morning_flights_tomorrow": "vols le lendemain matin",
    "yesterday_flights": "vols de hier soir",
    "action": "action",
    "version": "version",
    "messages": "messages",
    "assign": "attribuer",
    "assigned": "attribué",
    "assign_to": "attribuer un vol à",
    "close": "fermer",
    "apps": "ressources",
    "more": "plus"
  },
  "CALENDAR": {
    "MATRIX": {
      "plan_flight": "planifier un vol",
      "flyability_flight_location": "alerte flyability pour le site de ce vol",
      "pilot": "pilote",
      "driver_be": "chauffeur (BE)",
      "crew": "équipe",
      "occupancy": "occupation confirmée / ajoutée",
      "cancelled": "annulé",
      "conflict_tooltip": "plusieurs vols sur le même créneau — cliquez pour résoudre dans le planning du jour",
      "morning": "matin",
      "evening": "soir",
      "weather_anchor": "météo & soleil : site par défaut",
      "weather_anchor_tooltip": "la météo du jour et les heures de soleil concernent le site par défaut ; les cellules de vol montrent la flyability de leur propre site",
      "no_default_location": "définissez un site par défaut pour voir la météo du jour et les heures de soleil",
      "sunrise_tooltip": "lever du soleil au site par défaut",
      "sunset_tooltip": "coucher du soleil au site par défaut",
      "open_bookings": "réservations ouvertes",
      "load_more": "charger plus",
      "already_assigned_tooltip": "déjà affectée à ce vol — la déposer ailleurs la déplace, jamais de doublon",
      "open": "ouvertes",
      "events": "événements",
      "seats": "places",
      "move_overflow_title": "capacité insuffisante",
      "move_overflow_body": "Le ballon cible a moins de places que de passagers sur ce vol. Déplacer quand même ?",
      "flights": "vols",
      "available": "disponible",
      "no_availability_info": "pas d'info de disponibilité pour ce créneau",
      "edit_hint": "cliquez sur un champ d'info d'une carte pour le modifier en pop-up — édition complète via le détail du vol",
      "location": "site",
      "pilot_crew": "pilote & équipe",
      "weather": "météo",
      "lift": "portance",
      "comment": "commentaire",
      "edit_in_popup": "modifier en pop-up",
      "assign": "— à assigner",
      "move": "déplacer",
      "flight_detail": "détail du vol",
      "drop_bookings_here": "pas encore de réservations — déposez-les ici",
      "search_placeholder": "rechercher par nom, téléphone ou commentaire…",
      "search_hint": "Entrée — recherche côté serveur",
      "no_open_bookings": "pas de réservations ouvertes pour ce créneau",
      "waiting_list_hint": "déposez une réservation assignée ici pour la détacher",
      "back_to_classic": "retour au tableau de bord classique",
      "previous_week": "semaine précédente",
      "next_week": "semaine suivante",
      "this_week": "cette semaine",
      "classic_until": "disponible jusqu'au 31 mars 2027",
      "try_matrix_banner": "Essayez le nouveau tableau de bord avec planning hebdomadaire — il deviendra le standard le 31 mars 2027.",
      "try_matrix": "essayer",
      "create": "créer",
      "hour_derived": "automatique : lever/coucher du soleil au site choisi, offset inclus",
      "hour": "heure",
      "date": "date",
      "period": "créneau",
      "balloon": "ballon"
    },
    "waiting_list": "list d'attente",
    "no_bookings_yet": "aucune réservation pas encore",
    "drag_and_drop_reservations_here_to_add_to_this_flight": "glissez et déposez des réservations ici pour ajouter au vol",
    "drag_and_drop_reservations_here_to_remove_from_this_flight": "glissez et déposez des réservations ici pour supprimer du vol",
    "good_job": "bien travailler!",
    "all_bookings_are_added_to_a_flight": "toutes les réservations sont ajoutées à un vol",
    "you_cannot_drop_bookings_here": "vous ne pouvez pas déposer des réservations ici",
    "show_calendar_crew": "voir le planning crew",
    "set_month": "définir le mois",
    "clear_month": "supprimer tout",
    "plan": "plan",
    "refetch": "actualiser",
    "show_all_pilots": "voir tous les pilotes",
    "show_all_crew": "voir tous les crews"
  },
  "ACTORS": {
    "COM": "CPL",
    "NCO": "PPL",
    "NOL": "pas de license",
    "NOA": "pas d'accès",
    "OPR": "opérateur",
    "CRE": "pilot/crew (vols assignés)",
    "REP": "report viewer",
    "ASS": "Operator assistant (vols & réservations)",
    "MET": "météo (vols)",
    "user_role": "fonction",
    "name": "nom",
    "phone": "téléphone ",
    "email": "email",
    "used_for_login": "utilisé pour la connexion",
    "emailNotifications": "notifications par e-mail",
    "emails_from_the_system_will_be_send_to_this_address": "les e-mails du système seront envoyés à cette adresse, pas à l’adresse de connexion",
    "driver_license": "permis de conduire",
    "driver_license_none": "pas de permis",
    "pilot_license": "license pilote",
    "ground_crew": "crew",
    "language": "langue ",
    "confirm_message": "êtes-vous sûr de vouloir supprimer?",
    "confirm": "confirmer",
    "contacts": "contacts ",
    "update": "mettre à jour",
    "delete": "supprimer",
    "save": "enregistrer",
    "add_contact": "ajouter contact",
    "crew": "crew",
    "pilot": "pilot",
    "add_crew": "ajouter crew",
    "national_license": "license national",
    "part_fcl_license": "license PART-FCL",
    "license_group_A": "group A",
    "license_group_B": "group B",
    "license_group_C": "group C",
    "license_group_D": "group D",
    "license_gas": "ballon de gaz",
    "license_number": "numéro de license",
    "license_expiry_date": "date d'expiration OPC",
    "license_extra_crew": "license extra crew",
    "ground_crew_training_expiry_date": "formation équipage expire le",
    "first_aid_expiry_date": "échéance EHBO",
    "fire_extinguisher_expiry_date": "échéance extincteur",
    "medical_expiry_date": "échéance médical",
    "weight": "poids",
    "warning_not_current": "la validité du pilote expire dans les 30 jours, vérifiez les dates d’expiration",
    "error_not_current": "pilote cloué au sol, vérifiez les dates d’expiration",
    "assigned_to_flight": "assiste le vol",
    "your_flight": "ton vol",
    "your_flights": "tes vols",
    "pilots": "pilotes",
    "drivers": "BE-crew"
  },
  "BALLOONS": {
    "upload_photo": "charger une photo",
    "name": "Nom",
    "call_sign": "immatriculation",
    "capacity": "capacité",
    "total_weight": "poids total",
    "balloons": "ballons",
    "confirm_message": "êtes-vous sûr de vouloir supprimer?",
    "confirm": "confirmer",
    "update": "mettre à jour",
    "delete": "supprimer",
    "save": "enregistrer",
    "add_balloon": "ajouter un ballon",
    "group": "groupe",
    "MLM": "MTM (poids minimum d'atterrissage)",
    "MTOM": "MTOM (poids maximum au décollage)",
    "lift_warning_title": "zones d'alerte de lift",
    "lift_warning_explain": "couleur du lift de réserve par vol : douteux (orange) à partir de la première valeur, bon (vert) à partir de la seconde — sous la limite orange le vol passe au rouge. Le bleu apparaît si le vol pourrait atterrir sous la MLM.",
    "lift_warning_unconfigured": "non configuré — seul un lift de réserve négatif s'affiche en rouge",
    "lift_zone_red": "trop faible",
    "lift_zone_orange": "douteux",
    "lift_zone_green": "bon",
    "lift_orange_from": "douteux (orange) à partir de",
    "lift_good_from": "bon (vert) à partir de",
    "min_fuel": "consommation par heure (Litre par heure)",
    "liter_per_hour": "litre par heure",
    "fuel": "consommation par heure par 20°C et nombre max de passagers",
    "envelope": "enveloppe",
    "envelope_manufacturer": "constructeur de l'enveloppe",
    "envelope_type": "type d'enveloppe",
    "envelope_volume": "Volume de l'enveloppe",
    "envelope_weight": "poids de l'enveloppe",
    "envelope_hours": "nombre heures total de l'enveloppe",
    "envelope_inspection_date": "inspection valide jusqu'à",
    "balloon_temp": "température de l'enveloppe",
    "burner": "brûleur",
    "burner_manufacturer": "constructeur du brûleur",
    "burner_type": "type de brûleur",
    "burner_weight": "poids du brûleur",
    "cylinder_hint": "Enregistrez d'abord le ballon et ajoutez ensuite les cylindres. Assurez-vous de créer d'abord les cylindres dans le système. Les mêmes cylindres peuvent être utilisés sur plusieurs ballons",
    "cylinder": "bouteilles  de gaz",
    "cylinder_manufacturer": "constructeur",
    "cylinder_volume": "volume",
    "cylinder_count": "nombre",
    "cylinder_empty_weight": "poids à vide",
    "cylinder_full_weight": "poids plein",
    "cylinder_total_weight": "poids total",
    "cylinder_number": "numéro",
    "cylinder_serial": "matricule",
    "basket": "nacelle",
    "basket_manufacturer": "constructeur de la nacelle",
    "basket_type": "type de nacelle",
    "basket_weight": "poids de la nacelle",
    "insurance_company": "assurance",
    "insurance_due_date": "date d'expiration assurance",
    "add_cylinder": "add cylinder",
    "error_not_current": "Ballon échoué, mettre à jour les dates d’expiration",
    "warning_not_current": "ballon expire dans 30 jours, mettez à jour les dates d’expiration"
  },
  "VOUCHERS": {
    "status": "état",
    "create_booking": "create booking",
    "available": "disponible",
    "used": "reservé",
    "expired": "invalide",
    "voucher_type": "type",
    "show_all_types": "montrer tous les types",
    "voucher_reference": "référence",
    "issue_date": "date de création",
    "expiry_date": "date de validité",
    "contactName": "nom",
    "contactPhone": "téléphone",
    "contactLanguage": "langue",
    "contactEmail": "email",
    "contact_city": "ville",
    "recipient_info": "détails de la personne qui recevra et utilisera le bon",
    "buyer_info": "détails de la personne qui a acheté le bon",
    "details_info": "informations spécifiques sur le bon lui-même",
    "buyer": "acheté par",
    "recipient": "destinataire",
    "recipientName": "nom du destinataire",
    "recipientPhone": "téléphone",
    "recipientLanguage": "langue",
    "recipientEmail": "email",
    "recipientAddress": "adresse",
    "recipientPostalCode": "code postal",
    "recipientCity": "ville",
    "recipientCountry": "pays",
    "details": "détails",
    "comments": "commentaires",
    "paymentAmount": "montant",
    "paymentStatus": "état de paiment",
    "paymentDate": "date de paiment",
    "adults": "adultes",
    "children": "enfants",
    "external": "externe",
    "external_source": "source",
    "tickets": "tickets",
    "voucher": "bon de cadeau",
    "available_vouchers": "bons disponible",
    "confirm_message": "êtes-vous sûr de vouloir supprimer ce bon cadeau?",
    "unpaid_vouchers": "Attention! Il y a des bons non payés",
    "IMPORT": {
      "import": "import",
      "upload_csv": "upload CSV",
      "upload_valid_csv_with_this_header": "upload a valid CSV with the following header",
      "example_with_2_adults": "example of a voucher with 2 adults",
      "choose_file": "choose file",
      "check_file": "check file",
      "check_errors": "check errors",
      "not_a_valid_CSV": "this is not a valid CSV",
      "valid_CSV": "no validation errors",
      "click_import": "click import",
      "number_of_vouchers": "number of vouchers",
      "import_status": "import status",
      "imported_succesfully": "successfully imported",
      "imported_with_errors": "errors during import",
      "finish": "finish",
      "row": "row",
      "error_more_less_columns": "more or less columns than expected",
      "error_header": "error in the header",
      "error_contact_name": "error in contactName, this field is mandatory",
      "error_contact_phone": "error in contactPhone, this field is mandatory and in the format M:+32...",
      "error_contact_language": "error in contactLanguage, this field is mandatory",
      "error_voucher_type": "error in voucher type, this field is mandatory",
      "error_voucher_reference": "error in voucher reference, this field is mandatory",
      "error_issue_date": "error in issue date, this field is mandatory and in the format YYYY-MM-DD",
      "error_expiry_date": "error in expiry date, this field is mandatory and in the format YYYY-MM-DD",
      "error_payment_date": "error in payment date, this field is mandatory and in the format YYYY-MM-DD",
      "error_payment_status": "error in payment status, this field is mandatory and accepted values are OPEN or PAID",
      "error_payment_type": "error in payment type, this field is mandatory and accepted values are NOPA, CASH, WIRE, BANC, CRED, ONLI",
      "error_adults": "error in adults, this must be a number",
      "error_children": "error in children, this must be number",
      "error_import": "error during import",
      "succes_import": "imported successfully",
      "cancel": "cancel"
    }
  },
  "BOOKINGS": {
  	"email_export_tooltip_open_amount": "avec un solde ouvert",
    "email_passengers": "envoyer un courriel aux passagers",
    "email_export_tooltip": "exporter les adresses e-mail des passagers en CSV",
    "email_export_tooltip_dynamic": "Télécharger toutes les adresses e-mail des passagers ({{filter}}){{extras}}",
    "email_export_tooltip_tags": "avec le tag {{tags}}",
    "email_export_tooltip_search": "correspondant à '{{search}}'",
    "email_export_success": "{{count}} adresses e-mail exportées",
    "email_export_empty": "aucune adresse e-mail à exporter",
    "id": "no",
    "availability": "disponibilité",
    "PERI": "disponibilité - plusieurs jours",
    "DATE": "disponibilité pour un jour spécifique",
    "MOR": "matin",
    "EVE": "soir",
    "mo": "lu",
    "tu": "ma",
    "we": "me",
    "th": "je",
    "fr": "ve",
    "sa": "sa",
    "su": "di",
    "save": "enregistrer",
    "child": "enfant",
    "name": "nom",
    "weight": "poids",
    "luggage": "bagage",
    "paymentType": "type de paiement ",
    "paymentReference": "référence de paiement ",
    "paymentAmount": "montant de paiement ",
    "paymentStatus": "état de paiement ",
    "paymentDate": "date de paiment",
    "delete": "supprimer",
    "OPEN": "ouvert",
    "UNK": "ajouté",
    "INV": "invité par sms",
    "CON": "confirmé",
    "completed": "effectué",
    "CAN": "annulé",
    "CPP": "passagers commerciaux exclusifs",
    "COP": "passagers commerciaux",
    "NCP": "passagers non-commerciaux",
    "booking_date": "date de réservation",
    "days_expired": "{{ d }} jours expiré",
    "startDate": "date de début",
    "endDate": "date de fin",
    "status": "état",
    "bookingType": "type de réservation",
    "bookingCode": "Référance de la réservation",
    "bookingCodeHint": "cliquez afin d'ouvrir l'application de passagers",
    "bookingCodeMissingEmail": "sans email, les passagers n'ont pas accès à l'application de passagers",
    "commentsTitle": "commentaires",
    "comments": "commentaires internes",
    "pax_comments": "commentaires passager",
    "region": "région",
    "source": "source",
    "new_source": "nouvelle source",
    "you_can_manage_all_sources_in_settings": "vous pouvez gérer toutes les sources dans les paramètres",
    "source_validation": "source est obligatoire, min 3, max 50 caractères et doit être unique",
    "source_list_validation": "choisissez une source dans la liste ou créez d'abord une nouvelle source",
    "source_list_empty": "aucune source trouvée, ajoutez la première source",
    "locationType": "base de décollage",
    "REGI": "toutes les bases de décollages dans une région",
    "FIXE": "bases de décollage spécifique dans une région",
    "PRIV": "lieu de décollage privé",
    "logsRemoved": "nombre de fois où le vol a été supprimé",
    "contactPerson": "personne de contact",
    "contactName": "nom de contact ",
    "contactPhone": "téléphone de contact",
    "contactEmail": "email de contact",
    "contactLanguage": "langue de contact",
    "action_needed": "action nécessaire",
    "answer_flight_yes_no": "Répondez VOL OUI ou VOL NON",
    "flight_yes": "VOL OUI",
    "flight_no": "VOL NON",
    "PAID": "payé",
    "REFUNDED": "remboursé",
    "not_paid": "à payer",
    "CASH": "cash",
    "COUP": "bon (dans système)",
    "VOUC": "bon",
    "NOPA": "pas de paiment",
    "CHEQ": "chèque",
    "WIRE": "virement bancaire",
    "BANC": "bancontact",
    "CRED": "credit card",
    "ONLI": "online",
    "INVO": "facture",
    "only_available_with_paymenttype_voucher": "seulement disponsible avec type de payment bon",
    "bookings": "réservations",
    "booking": "réservation",
    "confirm": "confirmer",
    "update": "mettre à jour",
    "contact": "contact",
    "passengers": "passagers",
    "cancel": "annuler",
    "next": "suivant",
    "flightDate": "date de vol",
    "flightPeriod": "AM/PM",
    "flight_balloon": "ballon",
    "flight_location": "base de décollage",
    "flight_pilot": "pilote",
    "add_passenger": "ajouter passeger",
    "messages": "messages",
    "no_bookings_found": "aucune réservation trouvée",
    "inviteCount": "invité",
    "confirm_message": "êtes-vous sûr de vouloir supprimer cette réservation?",
    "delete_blocked_on_flight": "Retirez d'abord cette réservation du vol avant de pouvoir la supprimer.",
    "always_available": "toujours disponible dès",
    "limited_availability": "disponibilité limitée dès",
    "end_before": "vol avant",
    "passenger": "passager",
    "details": "détails",
    "payment_details": "paiments",
    "address_details": "adresse",
    "disability": "assistance requis",
    "category": "catégorie",
    "address": "addresse",
    "postalCode": "code postal",
    "city": "ville",
    "country": "pays",
    "signature": "signature",
    "added_flight": "vol planifié",
    "select_flight": "sélectionner vol",
    "no_flight_added": "pas de vol planifié",
    "no_flight_data": "les données s'affichent que pour un endroit de décollage et une date déterminée",
    "available_flights": "vols disponibles",
    "no_available_flights": "pas de vol disponible",
    "available_balloons": "ballons disponibles",
    "no_available_balloons": "pas de ballon disponible",
    "totalAmount": "montant total",
    "paid_amount": "payé",
    "openAmount": "solde à payer",
    "prepayment": "prepaiment",
    "prepaymentDate": "date de prepaiment",
    "passengers_to_pay": "passager(s) à payer",
    "default_weight_warning": "Poids par défaut - confirmation requise",
    "passengers_with_default_weight": "{{ count }} passager(s) avec poids par défaut",
    "confirm_weight": "Confirmer le poids",
    "mark_paid": "marque comme payé",
    "remove_from_passengerlist": "retirer de la liste passager",
    "add_to_passengerlist": "ajouter un(e) passager(e)",
    "checkin_passengers": "retour au check in",
    "view_checked_in": "montré les passagers enregistrés(check in)",
    "hide_checked_in": "cacher les passagers enregistrés (check in)",
    "check_in_all": "enregistrer tous",
    "import": "import",
    "upload_csv": "upload CSV",
    "upload_valid_csv_with_this_header": "upload a valid CSV file with the following header",
    "example_in_region_with_id_1_with_2_adults_and_0_children": "example of a booking with 2 adults in region with Id 1",
    "choose_file": "select file",
    "check_file": "check file",
    "check_errors": "correct the following errors",
    "not_a_valid_CSV": "this is not a valid file",
    "valid_CSV": "there are no errors",
    "click_import": "click to import",
    "number_of_bookings": "number of reservations",
    "number_of_objects_upcoming": "futurs",
    "number_of_objects_history": "terminés",
    "import_status": "import status",
    "imported_succesfully": "succesfully imported",
    "imported_with_errors": "errors during import",
    "finish": "finish",
    "row": "row",
    "error_more_less_columns": "more or less columns than expected",
    "error_header": "error in the header",
    "error_contact_name": "error in contactName, this field is mandatory",
    "error_contact_phone": "error in contactPhone, this field is mandatory and in the format M:+32...",
    "error_contact_language": "error in contactLanguage, this field is mandatory",
    "error_region": "error in region, this field is mandatory and must have the ID of the region",
    "error_adults": "error in adults, this must be a number",
    "error_children": "error in children, this must be a number",
    "errorImport": "error during import",
    "succesImport": "imported succesfully",
    "flight_confirmation": "vol confirmation",
    "date_filter_is_yyyy-mm-dd": "filtrer par date = yyyy-mm-dd",
    "FILTER": {
    	"standard": "toutes actives",
    	"standard_desc": "tout ce qui doit encore voler",
    	"toPlan": "à planifier",
    	"toPlan_desc": "pas encore de vol",
    	"toConfirm": "à confirmer",
    	"toConfirm_desc": "demandée par le passager",
    	"invited": "invitées",
    	"invited_desc": "en attente de la réponse du passager",
    	"confirmed": "confirmées",
    	"confirmed_desc": "fixée sur un vol",
    	"expired": "expirées",
    	"expired_desc": "validité dépassée, pas encore volé",
    	"history": "clôturées",
    	"history_desc": "volées ou annulées"
    },
    "import_bookings": "importer des réservations (CSV)",
    "expired_on_flight_date": "plus valable à la date du vol",
    "flight_confirmed": "vol confirmé",
    "invited_waiting_answer": "invité, réponse attendu",
    "MERGE": {
      "merge": "fusionner",
      "load": "charger",
      "restart": "redémarrer",
      "select_booking": "selectionner réservations",
      "select_booking_hint": "La réservation à gauche sera supprimée, celle à droite sera enregistrée",
      "merge_booking": "fusionner réservations",
      "merge_booking_hint": "donner votre accord avant de pouvoir enregistrer et supprimer",
      "booking_id_to_delete": "id de la réservation à supprimer",
      "booking_id_to_merge": "id de la réservation à fusionner",
      "error_loading": "erreur lors du chargement, sélectionnez une autre id ou redémarrez",
      "warning_to_switch": "avertissement: vous choisissez de supprimer la réservation la plus récente",
      "save_and_delete": "enregistrer cette réservation et supprimer",
      "confirm_to_delete": "accord pour supprimer",
      "replace": "remplacer",
      "add": "ajouter",
      "undo": "annuler",
      "fields_are_identical": "champs sont identiques",
      "remove": "supprimer"
    },
    "LOG": {
      "logbook": "historique",
      "outbox": "e-mails envoyés",
      "only_logs_from_UI": "Connexion de Quick Release (pas via UP ou via site web)",
      "ADDE": "ajouté  au vol",
      "REMO": "supprimé du vol",
      "CONF": "confirmé pour le vol",
      "cancel": "vol annulé, transféré à la liste des réservations",
      "COMP": "vol effectué, transféré aux listes des réservations exécutées",
      "INVI": "invité par MSG au vol",
      "CREA": "réservation créée dans le système",
      "update": "réservation modifiée (un ou plusieurs attributs)",
      "DELE": "réservation supprimée du système",
      "MAIL": "email envoyé",
      "TRANSFER": "transféré vers un autre panier",
      "view_email": "montrer email",
      "flight": "vol"
    },
    "invoice_name": "nom de la facture",
    "vat_number": "numéro de TVA",
    "age": "âge",
    "transport": "transport",
    "age_amount": "ans"
  },
  "COMMUNICATIONS": {
    "RETENTION": {
      "title": "conservation des messages",
      "explanation": "Choisissez la durée de conservation des messages. Les messages plus anciens disparaissent immédiatement du tableau de bord et sont définitivement supprimés après 90 jours — pendant ces 90 jours, vous pouvez les récupérer en rétablissant le réglage. Les messages des réservations ouvertes sont toujours conservés. En tant que responsable du traitement, vous choisissez et justifiez vous-même la durée de conservation.",
      "closedBookings": "réservations clôturées",
      "crew": "équipe",
      "never": "jamais (conserver toujours)",
      "years": "ans",
      "year": "an",
      "recommended": "recommandé : 2 ans",
      "recommendedShort": "recommandé",
      "confirmTitle": "supprimer les anciens messages ?",
      "confirmBody": "{{total}} messages ({{closedBookingMessages}} de réservations clôturées, {{crewMessages}} d'équipe) disparaîtront maintenant et seront définitivement supprimés après 90 jours. Pendant ces 90 jours, vous pouvez les récupérer en rétablissant le réglage ; ensuite ils seront perdus définitivement.",
      "policyClosedYears": "Les messages des réservations clôturées sont supprimés dès que le message lui-même a plus de {{years}} an(s).",
      "policyClosedNever": "Les messages des réservations clôturées sont conservés pour toujours. Attention : cela bloque l'établissement d'une nouvelle connexion WhatsApp.",
      "policyCrewYears": "Les messages d'équipe sont supprimés dès que le message lui-même a plus de {{years}} an(s).",
      "policyCrewNever": "Les messages d'équipe sont conservés pour toujours.",
      "pendingDeletion": "{{count}} messages sont programmés pour suppression — dans {{days}} jours ils seront définitivement supprimés.",
      "connectBlocked": "Pour connecter WhatsApp, vous devez d'abord définir une durée de conservation des messages pour les réservations clôturées (voir « conservation des messages » ci-dessous)."
    },
    "sent_at": "envoyé à ",
    "phone": "téléphone",
    "name": "nom",
    "text": "texte",
    "status": "état",
    "message_id": "ID de message",
    "message_price": "prix d'un message",
    "network": "réseau",
    "remaining_balance": "solde restant",
    "received_at": "reçu à",
    "msisdn": "msisdn",
    "message_timestamp": "temps de message",
    "keyword": "mot-clé",
    "pilot_invitation_sms": "SMS aux pilotes",
    "crew_invitation_sms": "SMS aux crews",
    "checkin_notification_sms": "invitation d'enregistrement",
    "booking_confirmation_sms": "confirmation de réservation",
    "passenger_invitation_sms": "SMS aus passagers",
    "cancel_sms": "SMS d'annulation",
    "reminder_sms": "SMS rappel",
    "reminder_wa": "WhatsApp rappel",
    "sms_in": "SMS entrant",
    "messages": "ID de message",
    "flight": "vol",
    "booking": "réservation",
    "crew": "crew",
    "sms_out": "SMS sortant",
    "to": "destinataire",
    "unanswered_messages": "messages non répondus",
    "mark_all_as_read": "marquer tous les {0} messages comme lus",
    "mark": "marquer",
    "mark_all": "marquer tous",
    "mark_paid": "marquer payé",
    "mark_not_paid": "marquer pas payé",
    "messages_as_read": "messages lus",
    "you": "tu",
    "mail_copy": "Email PDF",
    "action_succeed": "action réussie",
    "accepted": "accepté",
    "delivered": "livré",
    "sent": "envoyé",
    "failed": "n'a pas réussi à livrer",
    "unknown": "erreur inconnue",
    "retry": "réessayer plus tard",
    "wrongnumber": "mauvais numéro",
    "none": "rien",
    "fallback_hint": "WhatsApp hors ligne — crédits SMS disponibles. Activez le SMS de secours dans les paramètres.",
    "WHATSAPP": {
      "CHANNEL": {
          "chooser": "canal WhatsApp",
          "free": "WhatsApp gratuit",
          "freeHint": "appareil couplé — gratuit, mais non officiel ; Meta peut le bloquer",
          "business": "WhatsApp Business",
          "businessHint": "canal Meta officiel via votre propre compte Meta — pas de blocages, payant par message",
          "active": "actif",
          "settingUp": "en cours de configuration",
          "freeInactiveExplain": "WhatsApp Business est actuellement votre canal actif. Pour revenir à WhatsApp gratuit, votre numéro est découplé de l'API Meta et vous recouplez ensuite votre téléphone avec un code QR. Le repli SMS couvre la transition. Attention : Meta peut à nouveau bloquer le canal gratuit."
      },
      "CLOUD": {
          "dialogWindowNote": "Les destinataires qui ne vous ont pas écrit dans les dernières 24 heures reçoivent le texte du modèle approuvé ; vos modifications n'atteignent que les destinataires dans la fenêtre de 24 heures.",
          "windowAllOpen": "Tous les destinataires sont dans la fenêtre de 24 heures — votre texte part par WhatsApp tel quel.",
          "windowSomeClosed": "{{count}} destinataire(s) sur {{total}} sont hors de la fenêtre de 24 heures — ils recevront le texte du modèle approuvé.",
          "windowEditedWarning": "Attention : vous avez modifié le texte. Les {{count}} destinataire(s) hors de la fenêtre de 24 heures recevront quand même le TEXTE DU MODÈLE APPROUVÉ — votre modification n’atteint que les destinataires dans la fenêtre.",
          "auxTemplateOutOfWindow": "Les destinataires hors de la fenêtre de 24 heures reçoivent le lien UP et les propositions de vol sous forme de modèle fixe (texte défini par Quick Release, non modifiable).",
          "noFlightTypesHidden": "Cette réservation n'a pas encore de vol planifié — les modèles contenant des données de vol (invitation, rappel, check-in, annulation) sont donc masqués.",
          "windowClosedFreeform": "Hors de la fenêtre de 24h — utilisez un modèle.",
          "templatePickerButton": "modèle",
          "title": "Canal WhatsApp",
          "subtitle": "Choisissez comment vos messages WhatsApp sont envoyés : WhatsApp gratuit (appareil couplé) ou WhatsApp Business (officiel, via votre propre compte Meta). Le changement est possible dans les deux sens.",
          "intro": "WhatsApp Business envoie vos messages via l'API officielle de Meta : pas de téléphone couplé, pas de risque de blocage et une confirmation de remise par message.",
          "introBilling": "C'est un canal payant : vous connectez votre propre compte professionnel Meta avec votre propre moyen de paiement, et Meta vous facture directement. Quick Release ne facture rien pour ces messages.",
          "introCostEstimate": "Estimation basée sur vos messages des {{months}} derniers mois : ± {{cost}} par mois. En moyenne, vous avez envoyé {{total}} messages WhatsApp par mois, dont ± {{billable}} en dehors de la fenêtre de 24 h — seuls ceux-ci sont payants (± 0,03 € par message) ; les messages envoyés dans les 24 h suivant une réponse du client sont gratuits.",
          "introCostEstimateSms": "Estimation basée sur votre historique SMS des {{months}} derniers mois : ± {{cost}} par mois. En moyenne, vous avez envoyé {{total}} messages par mois, dont ± {{billable}} tomberaient en dehors de la fenêtre de 24 h — seuls ceux-ci sont payants (± 0,03 € par message) ; les messages envoyés dans les 24 h suivant une réponse du client sont gratuits.",
          "introTemplates": "Les messages hors de la fenêtre client de 24 heures partent via vos modèles de message approuvés ; les réponses dans la fenêtre restent en texte libre et gratuites.",
          "startSignup": "connecter avec Meta",
          "reconnectMeta": "reconnecter le compte Meta",
          "signupCancelled": "La connexion Meta n'a pas été finalisée. Vos réglages WhatsApp actuels sont inchangés.",
          "signupSuccess": "Compte WhatsApp Business connecté {{phone}}. Vos modèles de message sont en préparation.",
          "provisioningIntro": "Votre compte Meta est connecté. Terminez les étapes ci-dessous puis activez WhatsApp Business. D'ici là, vos messages continuent d'utiliser le canal actuel.",
          "stepWaba": "Compte WhatsApp Business connecté",
          "stepNumber": "Numéro de téléphone enregistré",
          "stepPayment": "Moyen de paiement ajouté dans Meta Business Suite",
          "stepTemplates": "Modèles de message approuvés par Meta",
          "paymentExplain": "Meta vous facture directement sur votre propre compte. Ajoutez un moyen de paiement dans Meta Business Suite (Facturation), puis confirmez ici. Sans moyen de paiement, les messages par modèle cesseront de partir.",
          "openMetaBilling": "ouvrir la facturation Meta",
          "paymentConfirm": "j'ai ajouté mon moyen de paiement",
          "paymentActionNeeded": "Meta signale un problème de paiement sur votre compte. Les messages basculent vers le SMS. Vérifiez votre moyen de paiement dans Meta Business Suite et confirmez ci-dessous.",
          "activate": "activer WhatsApp Business",
          "activateConfirmTitle": "Activer WhatsApp Business ?",
          "activateConfirmBody": "Désormais vos messages WhatsApp partent via l'API officielle de Meta sur votre propre compte. Vous pouvez revenir en arrière à tout moment.",
          "activateConfirmBodyNoPayment": "Vous n'avez pas encore confirmé de moyen de paiement. Les messages gratuits fonctionneront, mais les messages par modèle payants basculeront vers le SMS tant que Meta n'a pas de moyen de paiement. Activer quand même ?",
          "activated": "WhatsApp Business est actif.",
          "activeTitle": "WhatsApp Business actif",
          "messagingTier": "limite d'envoi",
          "templatesServing": "{{count}} modèle(s) de message approuvé(s) et en service.",
          "switchBack": "revenir à WhatsApp gratuit",
          "switchBackConfirmTitle": "Revenir à WhatsApp gratuit ?",
          "switchBackConfirmBody": "Votre numéro est libéré de l'API Meta et vous le couplez à nouveau comme appareil lié (QR code). Le repli SMS couvre la transition. Attention : le canal gratuit peut de nouveau être bloqué par Meta.",
          "switchedBack": "Retour à WhatsApp gratuit effectué. Couplez votre téléphone avec le QR code ci-dessous.",
          "statusApproved": "approuvé",
          "statusPending": "en attente d'approbation Meta",
          "statusPendingSince": "en attente d’approbation Meta depuis {{elapsed}}",
          "statusRejected": "refusé par Meta",
          "statusBlocked": "texte à corriger",
          "fixWordingHint": "Corrigez le texte dans l'écran des modèles de message et enregistrez - il sera automatiquement soumis à nouveau à Meta.",
          "freeChannelNote": "WhatsApp gratuit fonctionne via un appareil couplé sur une connexion non officielle ; Meta peut la bloquer ou la couper. Envisagez WhatsApp Business pour un canal garanti.",
          "metaLinksHint": "Votre compte, votre numéro et l'approbation de vos modèles se trouvent chez Meta — consultez-les dans WhatsApp Manager sur votre propre compte.",
          "openMetaAccount": "ouvrir WhatsApp Manager",
          "openMetaTemplates": "modèles de messages chez Meta",
          "openMetaNumbers": "numéros de téléphone chez Meta",
          "beforeYouStart": "avant de commencer, chez Meta",
          "prereqBusiness": "Un compte professionnel Meta (Meta Business Portfolio) au nom de votre entreprise — créez-le d'abord si vous n'en avez pas.",
          "prereqPayment": "Un moyen de paiement sur ce compte Meta : Meta vous facture directement les messages payants.",
          "prereqNumber": "Un numéro de téléphone pour WhatsApp : un nouveau numéro ou votre numéro WhatsApp Business actuel (il continue de fonctionner sur votre téléphone).",
          "openMetaBusiness": "ouvrir Meta Business",
          "openManual": "lire le manuel"
      },
      "settings": "paramètres",
      "whatsapp_OFF": "WhatsApp est désactivé",
      "whatsapp_OFF_hint": "Contactez-nous pour activer WhatsApp si vous avez un numéro WhatsApp for Business. WhatsApp via votre numéro privé n'est pas pris en charge.",
      "whatsapp_ON": "WhatsApp est activé",
      "whatsapp_ON_hint": "Tous les messages sont envoyés via WhatsApp. Choisissez d'utiliser SMS comme solution de secours si WhatsApp n'est pas disponible pour votre client.",
      "whatsapp_TRIAL": "WhatsApp est en mode d'essai",
      "whatsapp_TRIAL_hint": "Vous serez toujours invité à choisir entre SMS ou WhatsApp.",
      "fallbackSMS": "repli sur SMS",
      "fallbackSMS_hint": "utilisez SMS si WhatsApp n'est pas disponible",
      "fallbackSMS_no_credits": "aucun crédit SMS disponible. Rechargez pour activer le SMS de secours.",
      "connection": "connexion",
      "device_connected_successfully": "appareil connecté avec succès",
      "connect_your_device": "connectez votre appareil",
      "connect": "connecter",
      "disconnect": "déconnecter",
      "device": "appareil",
      "phone": "téléphone",
      "checking_device": "vérification de l'appareil",
      "not_supported_wa_message": "message WhatsApp non supporté"
    }
  },
  "DASHBOARDS": {
    "flights": "vols",
    "no_flights": "pas de vols",
    "upcoming": "vols futurs",
    "historical": "terminé",
    "this_month": "ce mois",
    "bookings": "réservations",
    "vouchers": "bons de cadeau",
    "open": "ouvert",
    "completed": "effectué",
    "expired": "expiré",
    "idea_voting": "idées",
    "search": "chercher",
    "payments": "paiements",
    "charts": "graphiques",
    "flights_of_today_and_tomorrow_morning": "les vols d'aujourd'hui ou le lendemain matin",
    "flights_of_next_7_days": "les vols des 7 jours suivants",
    "bookings_to_confirm_bookmarked_and_of_today_or_tomorrow_morning": "les réservations à confirmer, réserver pour un vol d'aujourd'hui ou le lendemain matin, les nouvelles réservations ou avec un drapeau dashboard",
    "basic_charts_of_reservations_and_flights": "graphiques des réservations et vols",
    "charts_are_no_longer_shown_on_the_dashboard_please_navigate_to_reports": "graphiques ne sont plus part du dashboard, vous les trouvez dans rapports",
    "navigate_to_reports": "Naviguer vers rapports",
    "most_recent_sms_per_contact": "conversations récentes",
    "messages_bookings": "messages réservations",
    "messages_crew": "messages équipage",
    "messages": "messages",
    "sms_bookings": "SMS réservations",
    "sms_crew": "SMS équipage",
    "show_all_messages": "tous",
    "show_messags_from_this_flight": "seulement ce vol",
    "show_messages_from_this_booking": "seulement cette réservation",
    "show_unread": "non lus"
  },
  "FLIGHTS": {
    "LIST_FILTER": {
    	"upcoming": "à venir",
    	"upcoming_desc": "encore à voler ou des 7 derniers jours",
    	"older": "non clôturés (anciens)",
    	"older_desc": "vols prévus il y a plus de 7 jours, pas encore clôturés",
    	"historical": "terminés",
    	"historical_desc": "volés ou annulés"
    },
    "show_expired_on_flight_date": "afficher les expirées à la date du vol ({{n}})",
    "BULK": {
      "selected": "{{count}} sélectionné(s) (max. {{limit}})",
      "clear_selection": "Effacer la sélection",
      "select_all_matching": "Sélectionner tous les vols filtrés",
      "actions": "Action groupée",
      "choose_action": "Choisir une action",
      "deselect_all": "Tout désélectionner",
      "make_public": "Rendre public",
      "make_private": "Rendre privé",
      "download_csv": "Télécharger CSV",
      "ACTION": {
        "SET_VISIBILITY_PUB": "Rendre les vols publics",
        "SET_VISIBILITY_PRI": "Rendre les vols privés",
        "ADD_TAG": "Ajouter un tag",
        "REMOVE_TAG": "Retirer un tag",
        "CANCEL": "Annuler les vols",
        "DELETE": "Supprimer les vols"
      },
      "recent_actions": "Actions groupées des dernières 24 heures",
      "no_recent_actions": "Aucune action groupée ces dernières 24 heures",
      "undone": "annulée",
      "undone_by": "Annulée par {{user}}",
      "too_many_matches": "{{total}} vols correspondent à ce filtre. Une action groupée est limitée à {{limit}} vols à la fois. Affinez la recherche, la période ou le filtre de tags, par exemple mois par mois.",
      "limit_reached": "Vous pouvez sélectionner au maximum {{limit}} vols pour une action groupée. Affinez la recherche, la période ou le filtre de tags.",
      "no_matches": "Aucun vol ne correspond à ce filtre.",
      "confirm_selected": "{{count}} vols sélectionnés.",
      "date_range": "Période",
      "will_update": "{{count}} seront modifiés",
      "will_stay_unchanged": "{{count}} ont déjà ce réglage",
      "will_skip": "{{count}} seront ignorés",
      "undo_hint": "Vous pouvez annuler cette action une seule fois dans les 24 heures.",
      "apply": "Appliquer à {{count}} vols",
      "updated": "{{count}} modifiés",
      "unchanged": "{{count}} inchangés",
      "skipped": "{{count}} ignorés",
      "restored": "{{count}} rétablis",
      "not_restored": "{{count}} non rétablis",
      "undo": "Annuler l'action",
      "undo_available_until": "Annulation possible jusqu'au",
      "SKIP": {
        "NOT_FOUND": "le vol n'existe plus",
        "NOT_UPCOMING": "le vol est annulé ou terminé",
        "HAS_BOOKINGS_FUTURE": "a des réservations : annulez-le séparément pour que les passagers soient informés",
        "HAS_BOOKINGS": "a des réservations",
        "NOT_SCHEDULED": "seuls les vols planifiés peuvent être supprimés",
        "ERROR": "erreur inattendue"
      },
      "UNDO_SKIP": {
        "CHANGED_SINCE": "modifié depuis, non rétabli",
        "NOT_FOUND": "le vol n'existe plus",
        "DELETED": "réservation supprimée",
        "ON_OTHER_FLIGHT": "réservation planifiée sur un autre vol",
        "NOT_OPEN": "réservation plus ouverte",
        "ERROR": "erreur inattendue"
      }
    },
    "CANCEL": {
      "title": "annuler le vol",
      "reason_from_message": "motif : {{reason}}",
      "change_reason": "modifier",
      "cancel_and_send": "annuler et envoyer le message",
      "cancel_and_send_crew": "annuler et envoyer le message + équipage",
      "cancel_only": "annuler uniquement",
      "cancel_only_warning": "les passagers ne seront pas prévenus",
      "confirm": "confirmer",
      "already_sent": "message d'annulation déjà envoyé",
      "send_failed": "le message n'a pas pu être envoyé — le vol n'a pas été annulé",
      "back": "retour"
    },
    "cancel_message_only": "envoyer uniquement le message d'annulation",
    "cancel_message_sent_chip": "message d'annulation envoyé — vol pas encore annulé",
    "passengers_not_notified": "les passagers n'ont pas été prévenus",
    "CHECKIN_LOG": {
    	"title": "check-in pilote",
    	"empty": "aucune modification pendant le check-in mobile",
    	"signoff_cleared": "signature du pilote effacée",
    	"signoff_signed": "le pilote a signé"
    },
    "cancelled_bookings": {
      "title": "passagers à l'annulation",
      "send_message": "envoyer le message d'annulation",
      "restore": "restaurer le vol",
      "restore_confirm": "Le vol sera restauré et les passagers qui y figuraient seront à nouveau ajoutés. Les réservations placées entre-temps sur un autre vol restent inchangées.",
      "restore_done": "Vol restauré, {{count}} réservation(s) rattachée(s).",
      "restore_skipped": "Non restauré : {{skipped}}.",
      "skip_DELETED": "la réservation n'existe plus",
      "skip_ON_OTHER_FLIGHT": "entre-temps sur un autre vol",
      "skip_NOT_OPEN": "la réservation n'est plus ouverte"
    },
    "go back": "retourner",
    "save": "enregistrer",
    "reset": "reset défaut",
    "unknown": "inconnue",
    "CON": "confirmé",
    "invited_by_sms": "invité par sms",
    "DEC": "refusé",
    "MOR": "matin",
    "EVE": "soir",
    "CPF": "vol commercial exclusif",
    "COF": "vol commercial",
    "NCF": "vol récréatif",
    "PRI": "non partagé",
    "PUB": "partagé",
    "SCH": "planifier",
    "REA": "marquer prêt",
    "MARK": {
      "SCH": "planifie",
      "REA": "marque prêt",
      "CAN": "annule",
      "FIN": "termine"
    },
    "INFO": {
      "SCH": "Rassemblez votre équipement et préparez-vous pour le vol",
      "REA": "Bravo! Ce vol est prêt au décollage",
      "CAN": "Ce vol est annulé, vous pouvez le supprimer du système",
      "FIN": "Ce vol est terminé, excellent travail!"
    },
    "checkin": "check in",
    "CAN": "annuler",
    "FIN": "terminer",
    "balloon": "ballon",
    "date": "date de vol",
    "period": "temps",
    "event": "événement",
    "hour": "heure",
    "hourMeeting": "heure de rendez-vous",
    "sunrise": "sunrise",
    "sunset": "sunset",
    "flight_type": "type de vol",
    "location": "base",
    "visibility": "visibilité web",
    "web": "web",
    "status": "état",
    "comment": "commentaire",
    "crew_comments": "commentaires de l'équipage",
    "pilot": "pilot",
    "pilot_status": "état",
    "action_needed": "action nécessaire",
    "ground_crew": "crew",
    "pilot_and_crew": "pilot et crew",
    "not_enough_data": "pas assez de données",
    "answer_pilot_yes_no": "Répondez PILOT OUI ou PILOT NON",
    "pilot_yes": "PILOT OUI",
    "pilot_no": "PILOT NON",
    "Flight date cannot be set in the past": "la date de vol ne peut pas être dans le passé",
    "answer_crew_yes_no": "Répondez CREW OUI ou CREW NON",
    "crew_yes": "CREW OUI",
    "crew_no": "CREW NON",
    "flights": "vols",
    "flight_bookings": "réservations",
    "UNK": "ajouté",
    "INV": "invité par sms",
    "invite_all": "SMS inviter tous",
    "inviteCount": "invitations",
    "invite_count_1": "invitation",
    "mo": "lu",
    "tu": "ma",
    "we": "me",
    "th": "je",
    "fr": "ve",
    "sa": "sa",
    "su": "di",
    "invite": "envoi sms",
    "mail": "email",
    "reply": "répondez ici",
    "sms": "sms",
    "whatsapp": "WhatsApp",
    "whatsapp_sms": "WhatsApp (backup sms)",
    "message": "message",
    "message_whatsapp": "message WhatsApp",
    "message_sms_fallback": "message SMS de secours",
    "confirm": "confirmer",
    "remove": "supprimer",
    "contactName": "nom de contact",
    "bookingType": "type de réservation",
    "region": "région",
    "passengers": "passagers",
    "no_bookings_selected": "aucune réservation sélectionnée",
    "matching_bookings": "réservations",
    "mismatching_bookings": "réservations sur un autre vol",
    "mismatchReasons": "correspondance des vols",
    "add_all": "ajouter tous",
    "add": "ajouter",
    "add_and_confirm": "ajouter + confirmer",
    "already_added": "déjà ajouté",
    "messages": "messages",
    "calendar": "calendrier",
    "download_manifest": "télécharger le manifeste",
    "send_sms_reminder": "SMS de rappel",
    "update": "mettre à jour",
    "are_you_sure": "êtes-vous sûr?",
    "reminder_sms_will_be_sent": "MSG rappel",
    "edit_sms": "changer SMS",
    "edit_wa": "changer WhatsApp",
    "preview_sms": "exemple",
    "send": "envoyez",
    "send_to_pax": "SMS aux PAX",
    "send_to_pax_and_crew": "SMS aux PAX et CREW",
    "send_up_url_with_sms": "envoyez UP url avec SMS",
    "send_up_url_with_msg": "envoyez UP url avec MSG",
    "upTitle": "Accédez directement à votre page de réservation personnelle via ce lien!\n[lien personnel sera envoyé]",
    "flightOptions": "options de vol",
    "flightOptionsTitle": "Nous serions ravis de vous accueillir à bord à l’une des dates suivantes :\n[liste personnelle des vols avec suffisamment de places sera envoyée]",
    "send_flightoptions_with_msg": "envoyer les options de vol avec MSG",
    "sent": "envoyé",
    "message_has_been_sent": "le message a été envoyé",
    "message_has_not_been_sent": "le message n'a pas été envoyé",
    "not_sent": "pas assez de données",
    "not_confirmed_bookings_will_be_removed_from_flight": "les réservations suivantes non confirmées seront supprimées du vol",
    "flight_will_be_cancelled": "le vol sera annulé",
    "flight_will_be_finished": "le vol sera cloturé",
    "flight_will_be_reopened": "le vol sera remis au planning",
    "yes_cancel_it": "oui annuler",
    "no_please": "non merci",
    "cancel_sms_will_be_sent": "SMS d'annulation va être envoyé",
    "not_cancelled": "pas annulé",
    "flight_has_not_been_cancelled": "le vol n'a pas été annulé",
    "confirm_message": "êtes-vous sûr de vouloir supprimer?",
    "flight_pilot_in_command": "commandant de bord",
    "invite_by_sms": "sms",
    "unsupported_phonenumber": "numéro de téléphone non supporté",
    "sms_unclear": "sms douteux",
    "no_pilot_in_command_selected": "aucun pilote sélectionné",
    "flight_crew": "crew",
    "no_crew_selected": "aucun crew séléctionne",
    "available_pilots_and_crew": "pilotes et crew disponible",
    "select_pilot": "choissisez pilote",
    "select_crew": "choissisez crew",
    "other_flight": "autre vol",
    "add_as_crew": "ajouter crew",
    "add_as_pilot": "ajouter pilote",
    "warning": "attention",
    "creating_a_flight_can_lead_to_costs": "la création d'un vol peut générer des coûts",
    "proceed": "continuer",
    "cancel": "annuler",
    "passenger_count": "passagers",
    "crew_count": "crew",
    "type": "type",
    "no_pilot": "pas de pilot ",
    "seats": "passagers",
    "delete": "supprimer",
    "set_ready": "prêt",
    "address": "addresse",
    "postalCode": "code postal",
    "city": "ville",
    "country": "pays",
    "manifest": "télécharger le manifeste",
    "certificates": "certificats",
    "takeoffTime": "heure de décollage",
    "landingLocation": "lieu d'atterrissage",
    "landingDetails": "détails d'atterisage",
    "total_weight": "poids total",
    "landingTime": "heure d'atterrissage",
    "flightTime": "temps de vol",
    "and": "et",
    "name": "nom",
    "ref": "réf",
    "amount": "montant",
    "weight": "poids",
    "signature": "signature",
    "reminder_sms": "MSG rappel",
    "also_to_pilot_and_crew": "adresser aussi aux crew et pilotes",
    "cancel_sms": "MSG d'annulation",
    "no_flights_found": "aucun vol trouvé",
    "no_location": "pas de base de décollage",
    "show": "montrer",
    "hide": "cacher",
    "lift": "lift",
    "lift_needed": "lift nécessaire",
    "lift_available": "lift disponible",
    "lift_spare": "lift de réserve",
    "lift_level_green": "marge de lift OK",
    "lift_level_orange": "lift de réserve faible",
    "lift_level_red": "lift de réserve trop faible",
    "lift_level_blue": "sous-chargé — risque d'atterrir sous la masse minimale à l'atterrissage (MLM)",
    "lift_level_unknown": "données de lift incomplètes",
    "takeoff_location": "Takeoff Location",
    "temp": "temperature",
    "takeoff_height": "altitude de décollage",
    "maximum_height": "altitude max",
    "temp_takeoff": "température ext décollage",
    "temp_takeoff_manual_hint": "saisie manuellement — cliquez pour reprendre la température Meteoblue",
    "temp_max": "température max dans l'enveloppe",
    "weather_qfe": "Pression au décollage (QNH)",
    "weather_pmax": "Pression maximume",
    "balloon_volume": "volume de l'enveloppe",
    "balloon_temp": "température de l'enveloppe",
    "create_add": "créer vol",
    "weather": "météo",
    "copy_weather_to": "copier météo vers",
    "use_meteoblue": "utiliser meteoblue",
    "skeyes_ballooning_bulletin": "skeyes ballooning bulletin",
    "use_skeyes": "utiliser Skeyes",
    "weather_forecast": "prévisions",
    "no_weather_forecast": "pas de prévisions disponible",
    "windSummary": "résumé du vent",
    "weather_source": "source",
    "weather_source_forced": "source officielle (paramètres météo)",
    "weather_forecast_date": "date de prévisions",
    "vfr_visual": "visibilité",
    "vfr_clouds": "nuages",
    "wind_gl": "vent au sol",
    "wind_gl_short": "wind GL",
    "wind_dir": "direction",
    "wind_gl_direction": "direction de vent ground level",
    "wind_10": "vent 1000FT",
    "wind_10_direction": "direction de vent 1000FT",
    "wind_20": "vent 2000FT",
    "wind_20_direction": "direction de vent 2000FT",
    "wind": "vent",
    "clear": "clear",
    "fuel_spare": "gaz de réserve",
    "planned_flight_time": "temps de vol planifié",
    "spare_flight_time": "temps de vol de réserve",
    "maximum_flight_time": "temps de vol disponible",
    "select_balloon": "sélectionnez le ballon",
    "select_location": "sélectionnez la base",
    "offsets": "changer offsets sunrise/sunset",
    "flight_hour_will_be_calculated_based_on_sunset_minus_the_offset_minutes": "le temps du vol est calculé sur base de sunset (ou sunrise) moins l'offset en minutes,arrondi à une demi-heure. Des valuers négatives sont permits (au cas de sunrise par exemple).",
    "offset_sunrise": "offset sunrise (minutes)",
    "offset_sunset": "offset sunset (minutes)",
    "payment_overview": "paiements",
    "go_back": "retour",
    "freeSpots": "disponibilité",
    "traject": {
      "trajectory": "trajet",
      "custom_flight_profile": "profil de vol personnalisé",
      "duration": "durée",
      "duration_is_required": "durée est obligatoire",
      "level": "niveau",
      "level_is_required": "niveau est obligatoire",
      "save": "enregistrer",
      "no_trajectory_without_meteo": "pas de trajet sans météo",
      "update_custom_profile": "mettre à jour profil personnalisé",
      "refresh_weather": "rafraîchir la météo",
      "talking_to_meteoblue": "parler à meteoblue",
      "refresh_hint": "meteoblue met à jour son modèle météo régulièrement. Une nouvelle actualisation est possible 4 heures après la dernière mise à jour."
    },
    "LANDING": {
      "landing": "atterrissage",
      "landing_details": "détails",
      "map": "map",
      "no_details": "pas de détails remplis",
      "landing_data": "Les données d’atterrissage ne peuvent être modifiées que dans l’écran d’enregistrement mobile pour l’instant",
      "refuelVolume": "volume de gaz ravitaillé",
      "update_log": "modifier le journal",
      "update_log_hint": "vous ne pouvez modifier que les données d'atterrissage ici. Ouvrez le vol pour modifier toutes les autres données de vol.",
      "open_flight": "ouvrir le vol"
    },
    "FILTER": {
      "date_range_filter": "filtre de plage de dates",
      "from": "de",
      "till": "jusqu'au",
      "excluded": "exclu",
      "no_date_filter_active": "pas de filtre de date actif",
      "enter_a_date_range": "entrez une plage de dates",
      "start_date": "date de début",
      "end_date": "date de fin",
      "month": "mois",
      "week": "semaine",
      "day": "jour",
      "flights": "vols"
    },
    "flight_no_bookings": "ce vol n'a pas encore de réservation",
    "mor_flight": "vol du matin",
    "eve_flight": "vol du soir",
    "mor_flights": "vols du matin",
    "eve_flights": "vols du soir",
    "no_mor_flights": "pas de vols du matin",
    "no_eve_flights": "pas de vols du soir",
    "responded_pilots": "les pilotes ont répondu",
    "delete_flight": "supprimer le vol",
    "toggle_visibility": "modifier la visibilité",
    "tags": "drapeaux",
    "COPY": {
      "copy_flight": "copier le vol",
      "select_multiple_dates": "sélectionnez plusieurs dates pour copier le vol avec le même lieu, ballon, pilote et équipage",
      "selected_dates": "dates sélectionnées",
      "no_tags": "aucun drapeau",
      "copy": "copier"
    },
    "PILOTANDCREW": {
      "selected": "sélectionné",
      "most_used": "le plus utilisé",
      "this_is_the_most_used_pilot_and_crew": "c'est le pilote et crew les plus utilisés pour ce ballon",
      "accept": "accepter",
      "all_pilots_and_crew": "tous les pilotes et crew",
      "select": "sélectionner"
    },
    "FREESPOTS": {
      "showAll": "Afficher tous les vols",
      "showOverbookings": "Afficher les surréservations",
      "freeSpots": "Afficher tous les vols avec {{count}} places libres ou plus",
      "showMore": "Afficher plus d'options"
    },
    "selected_flight": "Vol sélectionné",
    "selected_flight_hint": "Cette réservation est actuellement prévue pour ce vol",
    "possible_flights": "Prochains vols",
    "possible_flights_hint": "Ce sont les prochains vols pour lesquels cette réservation peut être programmée, en tenant compte des places disponibles et des restrictions de balises",
    "balloon_cannot_accept_passengers": "Le ballon ne peut pas accepter de passagers",
    "balloon_in_use_tooltip": "Le ballon est utilisé sur un autre vol avec des passagers. Changez vers un autre ballon pour ajouter des passagers ici.",
    "reduce_capacity_by_one_pax": "Réduire la capacité d'un passager",
    "reset_capacity": "Réinitialiser la capacité",
    "has_open_amount_tooltip": "Ce vol a des réservations avec un montant ouvert"
  },
  "DISPLAYEDCOLUMNS": {
    "hint": "Sélectionnez les colonnes et modifiez l'ordre par glisser-déposer selon vos préférences",
    "warning": "Attention, vous devez réinitialiser vos préférences après des modifications des définitions de colonnes",
    "flightsUpcoming": "Colonnes pour les vols à venir",
    "flightsBooking": "Colonnes pour les vols à partir des réservations",
    "flightsHistory": "Colonnes pour les vols historiques",
    "bookingsOpen": "Colonnes pour les réservations ouvertes",
    "bookingsHistory": "Colonnes pour les réservations historiques",
    "bookingsPayment": "Colonnes pour le suivi des paiements",
    "bookingsDashboard": "Colonnes pour le tableau de bord des réservations",
    "bookingsFlight": "Colonnes pour les réservations sur un vol",
    "bookingsFlightEnd": "Colonnes pour les réservations sur un vol terminé",
    "bookingsFlightCancelled": "Colonnes pour les réservations d'un vol annulé",
    "bookingsFlightAll": "Colonnes pour les réservations sur un vol",
    "bookingsFlightPayment": "Colonnes pour le suivi des paiements",
    "status": "statut",
    "name": "ballon",
    "nameBadge": "ballon",
    "date": "date",
    "event": "événement",
    "hour": "heure",
    "location": "lieu",
    "pilot": "pilote",
    "crew": "crew",
    "bookings": "réservations",
    "comments": "remarques",
    "passengers": "passagers",
    "passengersWeight": "poids",
    "action": "action",
    "bookingDate": "date de réservation",
    "contactName": "nom du contact",
    "phone": "téléphone",
    "region": "région",
    "city": "ville",
    "preferredDate": "disponibilité",
    "flightDate": "date du vol",
    "flightPeriod": "période de vol",
    "flight_balloon": "ballon du vol",
    "flight_location": "base du vol",
    "flight_pilot": "pilote du vol",
    "totalAmount": "montant total",
    "paid_amount": "payé",
    "openAmount": "solde",
    "flight_confirmation": "confirmer le vol",
    "messages": "messages",
    "up": "UP",
    "contactCard": "réservation",
    "passengersCard": "passagers",
    "mismatchReasons": "correspondance de vol",
    "mobile_view": "visible sur mobile"
  },
  "MANIFEST": {
    "fuel_consumption": "fuel consumption",
    "fuel_needed": "fuel required",
    "fuel_available": "fuel available",
    "load_chart_and_passenger_list": "Load Calculations and Passenger List",
    "passenger_list": "Passenger List",
    "weather_conditions": "Weather Conditions",
    "fuel_calculations": "Fuel Calculations",
    "load_chart": "Load Calculations",
    "after_flight": "After Flight",
    "visible_defects": "Visible Defects",
    "yes_no": "Yes/No",
    "date": "date",
    "signature": "signature",
    "defect": "defect",
    "action": "action",
    "certificate": "certificate",
    "authority": "authority",
    "initials": "initials",
    "confirmation": "this confims that the specified actions were executed according PART-ML and that the aircraft is declared as ready for the next flight."
  },
  "LOCATIONS": {
    "name": "nom",
    "description": "description",
    "region": "région",
    "address": "addresse",
    "postalCode": "code postal",
    "city": "ville",
    "country": "pays",
    "height": "hauteur",
    "maximum height": "altitude maximum",
    "locations": "bases de décollage",
    "confirm_message": "êtes-vous sûr de vouloir supprimer?",
    "confirm": "confirmer",
    "update": "mettre à jour",
    "delete": "supprimer",
    "regions": "régions",
    "save": "enregistrer",
    "add_location": "ajouter base de décollage",
    "add_region": "ajouter région",
    "hot_airfield": "hot airfield",
    "coordinates": "coordonnées géo",
    "geolocate": "géolocaliser",
    "no_results": "Impossible de géolocaliser",
    "contact": "contact",
    "takeoff_location": "base de décollage",
    "takeoff_location_subtitle": "Les coordonnées de la base de décollage sont utilisées pour la prévision météo, le calcul de la trajectoire et de la portance.",
    "meetingpoint": "point de rencontre",
    "meetingpoint_subtitle": "L'adresse du point de rencontre est communiquée aux passagers (UP).",
    "same_as_takeoff": "même que base de décollage",
    "meetingpointAddress": "addresse du point de rencontre",
    "search_address": "chercher une adresse",
    "CONTACT": {
      "name": "nom",
      "type": "type",
      "comment": "commentaire",
      "phone": "téléphone",
      "email": "email",
      "when_to_contact": "quand contacter",
      "how_to_contact": "comment contacter",
      "NOMSG": "personne ne sera contacté",
      "MAIL": "email",
      "SMS": "msg",
      "mail": "pendant la préparation du vol, la personne de contact recevra un email",
      "sms": "pendant la préparation du vol, la personne de contact recevra un msg",
      "no_message": "la personne de contact ne recevra pas de message pendant la préparation du vol",
      "add_sms_template": "ajouter template msg",
      "add_mail_template": "ajouter template email",
      "mail_template": "email template",
      "sms_template": "msg template",
      "warning_email": "vous n'avez pas encore envoyé d'email à la personne de contact",
      "warning_sms": "vous n'avez pas encore envoyé de sms à la personne de contact"
    }
  },
  "FLYABILITY": {
    "verdict_good": "bon pour voler",
    "verdict_marginal": "douteux",
    "verdict_nogo": "probablement pas volable",
    "no_assessment": "pas d'évaluation disponible",
    "all_within_limits": "tous les paramètres dans vos limites",
    "unknown_excluded": "pas de données pour {{parameters}} — non pris en compte",
    "advisory": "Cette évaluation n'est qu'une aide basée sur vos propres limites — le commandant de bord décide.",
    "param_windGl": "vent au sol",
    "param_wind500": "vent à 500 m",
    "param_gustSpread": "rafales au-dessus du vent au sol",
    "param_precipitation": "précipitations",
    "param_lowClouds": "nuages bas",
    "param_visibility": "visibilité"
  },
  "FORECAST": {
    "no_mobile": "Météo n'est pas disponible sur mobile",
    "select_favorite": "Sélectionnez un base comme favori pour afficher les prévisions météo",
    "no_forecast": "Pas de météo disponible pour cet endroit. Vérifier la latitude et la longitude",
    "remove_favorite": "supprimer comme favori",
    "mark_favorite": "marquer favori",
    "favorite_description": "ce base est votre base préféré. Les prévisions météo de meteoblue sont disponibles sur le tableau de bord pour ce base.",
    "non_favorite_description": "ce base n’est pas votre base préféré. Marquez que c’est votre base préféré pour afficher les prévisions météo de meteoblue sur le tableau de bord",
    "meteo": "météo",
    "time": "temps",
    "summary": "résumé"
  },
  "REGIONS": {
    "name": "nom",
    "locations": "bases",
    "no_locations_yet": "pas de bases",
    "name_required": "nom obligatoire",
    "change_color": "cliquez ici pour changer la couleur de la région",
    "reset_color": "réinitialiser la couleur",
    "confirm_color": "confirmer la couleur",
    "cancel_color": "annuler la couleur",
    "openBookings": "réservations ouvertes",
    "notusedyet": "aucune réservation",
    "move": "transférer toutes les réservations vers une autre région",
    "select_target_region": "sélectionnez la nouvelle région pour toutes les {0} réservations dans cette région"
  },
  "EVENTS": {
    "new_event": "nouvel événement",
    "information": "ajoute un événement sur un date spéficique ou ajouter les jours fériés",
    "new_crew_event": "nouvel rendez-vous",
    "crew_information": "ajoute un jour ou vous n'êtes pas disponible (pilot ou crew)",
    "holidays": "holidays",
    "load_public_holidays_of_year_from_country": "ajouter les jours fériés de {0} de {1}",
    "date": "date",
    "description": "description",
    "save": "enregistrer",
    "cancel": "annuler",
    "required": "obligatoire",
    "crew": "crew",
    "NO": "pas disponible",
    "YES": "disponible",
    "MAYBE": "peut-être disponible",
    "UNK": "disponibilité inconnue",
    "comment_availability": "De quoi devons-nous tenir compte le",
    "comment": "commentaire"
  },
  "SETTINGS": {
    "VARIANTS": {
      "duplicate": "dupliquer",
      "copySuffix": "(copie)",
      "reasonCode": "motif d'annulation",
      "reasonCodeHint": "En choisissant ce motif lors de l'annulation, ce message est présélectionné. Un motif appartient à un seul message.",
      "reasonGeneral": "— aucun (message général) —",
      "reasonTaken": "utilisé par {{label}}",
      "reasonRemoved": "(motif supprimé)",
      "default": "par défaut",
            "add": "ajouter une variante",
            "remove": "supprimer la variante",
            "label": "nom de la variante",
            "labelHint": "Facultatif — distingue plusieurs textes du même type de message (p. ex. « vol du matin », « dernière minute »).",
            "picker": "version du texte",
            "variant": "variante",
            "waIssues": "WhatsApp Business ne peut pas soumettre ce texte",
            "waRejected": "Refusé par Meta",
            "waResubmitHint": "Adaptez le texte et enregistrez — il sera automatiquement soumis à nouveau à Meta pour approbation.",
            "wabaColumn": "statut WhatsApp",
            "ISSUES": {
                "VARIABLE_AT_START": "commence par une variable",
                "VARIABLE_AT_END": "se termine par une variable",
                "ADJACENT_VARIABLES": "deux variables directement consécutives",
                "TOO_MANY_VARIABLES": "trop de variables par rapport au texte fixe",
                "UNKNOWN_PLACEHOLDER": "variable inconnue pour ce type de message",
                "TOO_LONG": "texte trop long",
                "EMPTY_TEXT": "pas de texte"
            }
        },
    "user_default_language": "langue par défault",
    "submit": "enregistrer",
    "preferences_language": "langue",
    "preferences_sms": "Préférences SMS",
    "smsTitle": "titre",
    "smsTemplate": "template",
    "pilotInvitationSms": "SMS pilote",
    "example": "exemple",
    "update": "mettre à jour",
    "crewInvitationSms": "SMS crew",
    "passengerInvitationSms": "SMS passagers",
    "cancelSms": "MSG d'annulation",
    "reminderSms": "MSG rappel",
    "locationContactSms": "SMS contact base",
    "checkinNotificationSms": "SMS notification check-in",
    "bookingConfirmationSms": "SMS confirmation de réservation",
    "platformUpLink": "lien UP (modèle fixe)",
    "platformFlightOptions": "propositions de vol (modèle fixe)",
    "emailTitle": "titre",
    "no_emailTitle": "pas de titre",
    "emailType": "type",
    "emailTo": "email à",
    "emailSubject": "sujet",
    "emailBody": "message",
    "emailAttachments": "annexes",
    "emailAttachments_save_hint": "n'oubliez pas de sauvegarder votre template après avoir ajouté ou supprimé des annexes",
    "emailTest": "email test",
    "mailFromEmail": "E-mail envoyé avec l'adresse",
    "mailFromName": "E-mail envoyé avec le nom",
    "mailReplyToEmail": "Réponse sur l'adresse",
    "mailAccountantName": "nom de l’e-mail du comptable",
    "mailAccountantEmail": "adresse e-mail du comptable",
    "bookingConfirmEmail": "Email confirmation de la réservation",
    "bookingFlightCancelEmail": "Email fin de vol",
    "bookingFlightConfirmEmail": "Email passagers d'un vol",
    "crewFlightEmail": "Email détails de vol aux crews",
    "crewOtpEmail": "Email code pour crews",
    "pilotFlightEmail": "Email détails de vol pour pilots",
    "flight_email": "Email détails de vol",
    "locationContactEmail": "Email contact base",
    "checkinNotificationEmail": "Email notification check-in",
    "flight_email_passengers": "Email passagers",
    "flight_msg_passengers": "MSG passagers",
    "load_default": "chargez un text standard",
    "passenger_categories": "catégories de passager",
    "category_name": "nom",
    "category_description": "description",
    "category_child": "enfant",
    "category_price": "prix",
    "category_default": "par défaut",
    "delete": "supprimer",
    "mobile_questions": "questions aux passagers (mobile)",
    "question": "question",
    "kind": "enfant",
    "active": "actif",
    "title": "titre",
    "description": "description",
    "language": "langue",
    "texts": "textes",
    "name": "nom",
    "address": "addresse",
    "email": "email",
    "weight": "poids",
    "luggage": "bagage",
    "child": "enfant",
    "accompany": "adulte accompagnant",
    "pay": "payer",
    "signature": "signature",
    "optional": "optionnelle",
    "mandatory": "obligatoire",
    "order": "séquence",
    "titles": "questions",
    "descriptions": "decriptions",
    "yes": "oui",
    "no": "non",
    "nl": "néerlandais",
    "fr": "français",
    "en": "anglais",
    "de": "allemand",
    "es": "espagnol",
    "id": "id",
    "download_sample": "télécharger exemple",
    "drag_and_drop_file_here": "déposer le fichier ici",
    "browse_for_file": "télécharger un fichier",
    "operator_settings": "préférences generales",
    "operator_backup_and_sync": "backup en sync",
    "operator_bookings": "préférences réservation",
    "operator_flights": "préférences vol",
    "operator_crew": "préférences crew",
    "operator_myflight": "préférences UP (Passengers App)",
    "operator_weather_source": "paramètres météo et NOTAM",
    "flyability": {
      "enabled": "afficher la volabilité sur la carte météo",
      "disabled_hint": "Désactivé : la carte météo et le détail du vol restent exactement comme aujourd'hui, sans verdicts ni couleurs. Activez-le pour évaluer chaque créneau de prévision selon les limites ci-dessous.",
      "band_good": "bon",
      "band_marginal": "douteux",
      "band_nogo": "ne pas voler",
      "explain_windGl": "Vitesse moyenne du vent au sol pendant la fenêtre de vol. Elle détermine si le gonflage, le décollage et l'atterrissage sont possibles en sécurité — c'est la limite qui fait annuler la plupart des vols.",
      "explain_wind500": "Vitesse du vent à environ 500 mètres, l'altitude où le ballon passe l'essentiel du vol. Elle fixe la vitesse et la distance parcourue, donc la zone d'atterrissage nécessaire.",
      "explain_gustSpread": "De combien les rafales dépassent le vent au sol régulier. Des rafales de 8 kt au-dessus d'un vent calme de 5 kt provoquent quand même des à-coups sur l'enveloppe au gonflage et à l'atterrissage — d'où une évaluation séparée du vent lui-même.",
      "explain_precipitation": "La pluie la plus forte attendue pendant la fenêtre de vol. Une enveloppe mouillée est lourde et doit être séchée ensuite : la plupart des opérateurs gardent la zone verte à zéro.",
      "explain_lowClouds": "La part du ciel couverte par des nuages sous environ 2 km. Beaucoup de nuages bas signifie une base nuageuse basse et peu de vue sur le sol : 0 % est un ciel dégagé, 100 % est entièrement couvert.",
      "explain_visibility": "Jusqu'où vous voyez à l'horizontale. Elle sert à naviguer, à repérer les autres aéronefs et à choisir un champ à temps. C'est le seul paramètre où plus il y en a, mieux c'est : ses limites se comptent vers le haut.",
      "title": "limites de volabilité",
      "hint": "La carte météo colore chaque créneau de prévision en vert, orange ou rouge selon ces limites. Laissez un paramètre sur sa valeur par défaut pour continuer à suivre la valeur de la plateforme.",
      "good_upto": "bon jusqu'à",
      "marginal_upto": "douteux jusqu'à",
      "good_from": "bon à partir de",
      "marginal_from": "douteux à partir de",
      "is_default": "par défaut",
      "reset": "réinitialiser",
      "reset_all": "tout réinitialiser",
      "saved": "limites de volabilité enregistrées",
      "error_required": "les deux valeurs sont obligatoires",
      "error_negative": "les valeurs ne peuvent pas être négatives",
      "error_order": "la limite bon ne peut pas être plus stricte que la limite douteux"
    },
    "weatherSource": {
        "title": "source météo officielle par pays",
        "hint": "Si activé, la source météo du vol et du plan de vol opérationnel (OFP) est remplie automatiquement avec la source officielle du pays du lieu de décollage, au lieu d'un texte libre.",
        "mapped": "imposer la source météo officielle par pays",
        "source": "source météo",
        "locations": "lieux",
        "locationsWithoutCountry": "lieux sans pays (veuillez renseigner le pays)",
        "addCountry": "ajouter un pays"
    },
    "export": "export",
    "you_can_activate_a_daily_backup": "vous pouvez envoyer un export journalier en HTML à une addresse email. Dès que vous activez le export, vous recevrez immédiatement un export par email, ensuite chaque jour à 4 heures.",
    "daily_backup": "daily export",
    "backup_email": "email",
    "only_update_when_inactive": "vous ne pouvez pas changer l'adresse si le export est active",
    "exported_files": "fichiers exportés",
    "bookings": "toutes les réservations ouvertes",
    "flights": "tous les vols planifiés",
    "vouchers": "tous les bons cadeau",
    "flights_bookings_passengers": "tous les vols planifiés avec leur réservations et leurs passagers",
    "calendarUrl": "URL ICS pour le calendrier",
    "you_can_subscribe_to_all_flights_in_your_personal_calendar": "vous pouvez vous abonner à tous les vols dans votre calendrier personnel",
    "geticsurl": "générer l'URL ICS",
    "readthedocs": "lire la documentation",
    "crew": {
      "title": "Crew",
      "shareBookings": "crew peut voir le détail des réservations sur un vol dans le tableau de bord",
      "shareBookingsHint": "si cela n’est pas coché, crew ne peut voir que le nombre de passagers sur un vol dans le tableau de bord",
      "allowFlightSelection": "crew peut sélectionner des vols dans le calendrier",
      "allowFlightSelectionHint": "si cette option n’est pas cochée, crew ne peut voir que les vols dans le calendrier, mais ne peut pas les sélectionner",
      "shareEvents": "partager les événements du calendrier avec l'équipage",
      "shareEventsHint": "si coché, les événements opérateur (ex. vacances, événements d'entreprise) seront visibles par l'équipage dans leur calendrier",
      "shareFlightTags": "partager les tags de vol avec l'équipage",
      "shareFlightTagsHint": "si coché, les tags de vol seront visibles par l'équipage dans leur calendrier",
      "crewReady": {
        "title": "Notification équipage prêt",
        "channel": "canal de notification",
        "channelNone": "aucun (désactivé)",
        "channelEmail": "e-mail",
        "channelWhatsApp": "WhatsApp",
        "channelBoth": "Les deux (e-mail + WhatsApp)",
        "instructions": "instructions équipage",
        "includePassengers": "inclure les passagers dans la notification",
        "includeTrajectory": "inclure l'image de trajectoire dans la notification",
        "language": "langue de notification",
        "hint": "L'équipage est automatiquement informé par WhatsApp ou e-mail lorsque le statut du vol passe à prêt. La notification comprend les détails du vol et éventuellement les passagers et la trajectoire.",
        "preview": "aperçu"
      }
    },
    "operator_notifications": "notifications",
    "notifications": {
      "title": "Notifications par e-mail",
      "title_calendar": "Notification par e-mail de modification de disponibilité",
      "title_flightCrew": "Notification par e-mail de modification du pilote et/ou de l'équipage d'un vol",
      "calendar": "Recevez un e-mail lorsque la disponibilité de l'équipage et des pilotes change",
      "calendarHint": "si cette option est cochée, le système enverra automatiquement un e-mail clair à l'opérateur et à l'équipage 5 minutes après qu'un membre de l'équipage ou un pilote ait modifié une ou plusieurs disponibilités",
      "calendarClosing": "texte de fermeture",
      "calendarClosingHint": "Ce texte de fermeture est ajouté à chaque e-mail",
      "flightCrew": "Envoyez un e-mail lorsque vous ajoutez un pilote ou un membre d'équipage à un vol",
      "flightCrewHint": "si cette option est cochée, un e-mail sera automatiquement envoyé au pilote et à l'équipage lorsque vous les ajoutez ou les retirez d'un vol",
      "save": "enregistrer"
    },
    "booking": {
      "title": "Réservations",
      "childAge": "âge des enfants",
      "childAgeHint": "Chaque passager de cet âge ou moins sera automatiquement désigné comme enfant.",
      "disabledPaymentTypes": "types de paiement désactivés",
      "disabledPaymentTypesHint": "si vous désactivez un type de paiement, il ne sera pas affiché dans l'application de réservation.",
      "none_of_the_paymentTypes_are_disabled": "aucun type de paiement n'est désactivé",
      "disabledPaymentTypesSave": "enregistrer les types de paiement désactivés",
      "sources": "sources",
      "flightOptionsCount": "nombre d'options de vols",
      "flightOptionsCountHint": "Le nombre de prochains vols en montgolfière adaptés à la réservation, en tenant compte du nombre de passagers et des éventuelles restrictions (tags)."
    },
    "flight": {
      "title": "vols",
      "sunriseOffset": "décalage de lever du soleil",
      "sunriseOffsetHint": "l'heure du vol est calculée sur la base du lever du soleil moins le nombre de minutes de décalage, arrondi à la demi-heure inférieure.",
      "sunsetOffset": "décalage de coucher du soleil",
      "sunsetOffsetHint": "l'heure du vol est calculée sur la base du coucher du soleil moins le nombre de minutes de décalage, arrondi à la demi-heure inférieure.",
      "meetingTimeOffset": "décalage de l'heure de rendez-vous",
      "meetingTimeOffsetHint": "l'heure du rendez-vous pour le vol est calculée sur la base de l'heure du vol moins le nombre de minutes de décalage. Si 0, l'heure du rendez-vous n'est pas affichée.",
      "sunrise": "lever du soleil",
      "sunset": "coucher du soleil",
      "hourMeeting": "heure de rendez-vous",
      "hour": "heure de décollage",
      "save": "enregistrer les décalages",
      "save_hint": "Les nouveaux offsets s’appliquent uniquement aux trajets créés à partir de maintenant",
      "save_and_update_hours": "enregistrer et mettre à jour les heures de vol",
      "save_and_update_hours_hint": "tous les vols à venir seront mis à jour avec les nouveaux décalages",
      "cancelReason": "raison de l'annulation",
      "cancelReasons": "raisons d'annulation",
      "cancelReasonsHint": "si vous ne spécifiez aucune raison d'annulation, le système affichera toujours la raison par défaut.",
      "cancelReasons_list_empty": "aucune raison d'annulation trouvée, ajoutez votre première raison d'annulation",
      "new_cancelreason": "nouvelle raison d'annulation",
      "you_can_manage_all_cancelreasons_in_settings": "vous pouvez gérer toutes les raisons d'annulation dans les paramètres",
      "cancelreason_validation": "raison d'annulation obligatoire, min 3, max 50 caractères et doit être unique",
      "defaultPeriod": "période par défaut",
      "defaultPeriodHint": "choisir la période par défaut pour la création de nouveaux vols entre vols du matin ou du soir",
      "morning": "matin",
      "evening": "soir",
      "duplicateProtection": "protection contre les vols en double",
      "duplicateProtectionHint": "Empêche un ballon d'être planifié pour plusieurs vols simultanément. Vous ne pouvez pas ajouter de passagers à un vol si le même ballon a déjà un autre vol actif à ce moment.",
      "duplicateProtection_enabled": "protection activée",
      "duplicateProtection_disabled": "protection désactivée"
    },
    "myflight": {
      "title": "Quick Release UP (Passengers App)",
      "autoConfirm": "confirmer automatiquement le vol lorsqu’il est demandé via UP",
      "autoConfirmHint": "si cela n’est pas coché, l’opérateur doit confirmer le vol manuellement, lorsqu’il est ajouté via UP",
      "autoConfirmEmailTemplate": "modèle d'e-mail de confirmation",
      "autoConfirmEmailTemplateHint": "sélectionnez un modèle d'e-mail à envoyer automatiquement au passager lorsque la réservation est confirmée",
      "noEmailTemplate": "pas d'e-mail automatique",
      "autoConfirmAPI": "confirmer automatiquement via API (website)",
      "autoConfirmAPIHint": "si cela n’est pas coché, l’opérateur doit confirmer le vol manuellement, lorsqu’il est ajouté via l’API (website)",
      "endOfSeason": "fin de saison",
      "endOfSeasonHint": "si cette option est cochée, les vols ne peuvent plus être réservés via UP dès fin de saison",
      "flights": "quels vols sont visibles dans UP",
      "ALL": "tous les vols, en tenant compte des restrictions de drapeux",
      "REGIONAL": "vols régionaux (tous les vols planifiés dans la région de la réservation)",
      "NONE": "aucun vol (les passagers ne peuvent pas réserver via UP)",
      "parameters": "paramètres",
      "branding": "branding",
      "logo": "logo",
      "logoHint": "téléchargez un logo qui sera affiché dans l'application UP",
      "drag_and_drop_file_here": "glissez et déposez votre fichier .jpg ou .png ici (max 500kB)",
      "colors": "couleurs",
      "colorsHint": "cliquez sur chaque couleur pour les adapter à votre propre style. Vous pouvez choisir une couleur dans la palette de votre logo dans la pop-up",
      "example": "exemple",
      "reset": "réinitialiser couleurs",
      "save": "enregistrer couleurs et logo",
      "primary_background_color": "couleur d'arrière-plan de l'application",
      "secondary_background_color": "couleur d'arrière-plan des tuiles",
      "primary_foreground_color": "couleur du texte",
      "secondary_foreground_color": "couleur du texte d'information",
      "invalid_file_type_or_size": "type de fichier invalide ou fichier trop grand",
      "attachment_not_found": "Fichier joint introuvable — veuillez supprimer et re-télécharger",
      "translations": "Traductions",
      "change_translations": "Certains textes peuvent être personnalisés",
      "click_button_to_change_translations": "Ouvrez l'écran de connexion de l'application UP pour les passagers avec le bouton ci-dessous. Connectez-vous avec une réservation test ou l'une de vos réservations existantes. Partout où vous voyez l'icône suivante, vous pouvez ajuster la traduction.",
      "goto_api_settings": "Vous avez besoin d'une clé API pour pouvoir modifier les traductions. Allez dans les paramètres API pour générer une clé API.",
      "update_translations": "Mettre à jour les traductions"
    },
    "sms": {
      "footerEnabled": "ajouter un pied de page aux SMS",
      "footerEnabledHint": "si cette option n’est pas cochée, le pied de page ne sera pas ajouté à tous les SMS d’invitation"
    },
    "api": {
      "external_connection": "connexions externes",
      "external_connection_subtitle": "connectez votre site web ou d'autres applications avec Quick Release",
      "apiKey": "Clé API",
      "generateApiKey": "Générer la clé API",
      "noKeyMessage": "Vous n'avez pas encore de clé API. Générez une clé API pour accéder à l'API.",
      "documentation": "Documentation",
      "documentationDescription": "Lisez la documentation pour plus d'informations sur l'API.",
      "apiPlayground": "Console API",
      "FlightAppDocumentation": "FlightApp documentation",
      "FlightAppHint": "Connectez Quick Release aux journaux de bord numériques reconnus de FlightApp. Les vols terminés sont automatiquement transmis à FlightApp. Quick Release vérifie auprès de FlightApp la validité des ballons et des pilotes.",
      "FlightAppApikeyNotValid": "Erreur: cette FlightApp API key est invalide",
      "FlightAppAircraftNotValid": "Erreur: ce FlightApp ballon n'a pas été trouvé dans le système. Veuillez vérifier le callsign.",
      "FlightAppPilotNotValid": "Erreur: ce FlightApp pilote n'a pas été trouvé dans le système. Veuillez vérifier l'adresse email.",
      "addFlightAppApiKey": "Ajouter une clé API FlightApp",
      "hideApiKey": "API Key masquer",
      "showApiKey": "API Key afficher",
      "copyToClipboard": "Copier",
      "newApiKey": "Nouvelle API Key",
      "newApiKeyHint": "Entrez la nouvelle API Key",
      "updating_keys": "les clés API sont en cours de modification"
    },
    "callback": {
      "title": "URL de rappel",
      "subtitle": "Définissez une URL de rappel pour recevoir des notifications concernant les événements de réservation. La charge utile JSON contient l’identifiant de réservation (bookingId), l’identifiant de vol (flightId) et le nouveau statut de la réservation",
      "url": "URL de rappel",
      "noUrlMessage": "Aucune URL de rappel n’est définie. Cliquez sur le bouton ci-dessous pour en définir une.",
      "setUrl": "Définir l’URL de rappel",
      "saveUrl": "Enregistrer l’URL",
      "clearUrl": "Effacer l’URL"
    },
    "security": {
      "title": "Sécurité",
      "twoFA": "Authentification à deux facteurs",
      "description": "L'authentification à deux facteurs ajoute une couche supplémentaire de sécurité à votre compte. Sur les appareils non fiables, vous devrez saisir un code supplémentaire à 6 chiffres que vous recevrez par e-mail.",
      "enableTwoFA": "Activer l'authentification à deux facteurs",
      "enableTwoFAConfirm": "Activer l'authentification à deux facteurs vous déconnectera immédiatement. Êtes-vous sûr ?",
      "mandatory": "L'authentification à deux facteurs est obligatoire à partir du 01 janvier 2026"
    },
    "MESSAGING": {
      "ENABLED": "La messagerie est activée",
      "ENABLED_HINT": "Les messages sont envoyés via WhatsApp. Si WhatsApp n'est pas disponible, le SMS de secours peut être utilisé.",
      "DISABLED": "La messagerie est désactivée",
      "DISABLED_HINT": "Contactez Quick Release pour activer la messagerie pour votre compte.",
      "STATUS_CONNECTED": "WhatsApp connecté",
      "STATUS_DISCONNECTED": "WhatsApp déconnecté",
      "FALLBACK_WARNING": "WhatsApp n'est pas disponible. Le message sera envoyé par SMS (des frais s'appliquent).",
      "RECONNECT_INSTRUCTIONS": "Veuillez reconnecter votre appareil WhatsApp en scannant le code QR ci-dessous."
    },
    "checkin_title": "Enregistrement en ligne",
    "checkin_mode_none": "pas de check-in",
    "checkin_mode_none_hint": "Le check-in n'est pas utilisé.",
    "checkin_mode_pdf": "check-in PDF (manuel)",
    "checkin_mode_pdf_hint": "Imprimez la feuille de check-in avec vos instructions ; les passagers signent sur papier le jour du vol.",
    "checkin_mode_online": "check-in PDF + en ligne",
    "checkin_mode_online_hint": "Les passagers s'enregistrent en ligne avant le vol via l'application de réservation ; la feuille PDF reste disponible. Un canal de notification (e-mail ou WhatsApp) est requis.",
    "checkin_days_before": "Jours avant le vol",
    "checkin_notification_channel": "Canal de notification d'enregistrement",
    "checkin_instructions": "Instructions d'enregistrement (Markdown)",
    "checkin_save_instructions": "enregistrer les instructions de check-in",
    "checkin_load_default": "Charger les instructions par défaut",
    "checkin_preview": "Aperçu",
    "checkin_schedule_explanation": "Lorsque l'enregistrement est activé, les passagers peuvent s'enregistrer en ligne {{days}} jours avant leur vol via l'application de réservation. Une notification est envoyée automatiquement chaque jour à 10h00 (heure belge) aux réservations confirmées dont la fenêtre d'enregistrement est ouverte.",
    "checkin_passenger_explanation": "Ce texte est affiché lors du check-in en ligne (le passager doit confirmer l'avoir lu et compris) et est imprimé sur la feuille de check-in PDF au-dessus des signatures. Après le check-in en ligne, la réservation devient en lecture seule dans l'application.",
    "checkin_channel_title": "Canal de notification",
    "checkin_inapp_title": "texte de check-in",
    "checkin_email_preview_title": "Notification par e-mail",
    "checkin_email_preview_subject": "Objet",
    "checkin_whatsapp_preview_title": "Notification WhatsApp",
    "checkin_email_template_hint": "Ce modèle peut être personnalisé dans Paramètres → Modèles d'e-mail",
    "checkin_sms_template_hint": "Ce modèle peut être personnalisé dans Paramètres → Modèles SMS/WhatsApp. Le lien de réservation est envoyé automatiquement dans un message séparé."
  },
  "REPORTS": {
    "flights": "vols",
    "bookings_open": "réservations ouvertes",
    "bookings": "réservations nouvelles",
    "vouchers": "bons cadeau",
    "payments": "paiements",
    "sms": "MSG"
  },
  "MAIL": {
    "hide": "cacher détails",
    "show": "montrer détails",
    "sent": "envoyé",
    "error": "échec de l'envoi"
  },
  "TENANT_ACTIONS": {
    "WHATSAPP_PAIR_REQUIRED": "Reconnexion WhatsApp requise. Vos messages ne seront envoyés qu'une fois le nouveau QR code scanné.",
    "WHATSAPP_SESSION_DISCONNECTED": "Votre WhatsApp est déconnecté. Reconnectez-vous pour continuer à envoyer des messages.",
    "cta": "Reconnecter maintenant",
    "dismiss": "Fermer la notification"
  },
  "SUBSCRIPTION": {
    "WA_CLOUD": {
            "billable": "WhatsApp Business payant (Meta)",
            "free": "WhatsApp Business gratuit",
            "info": "Indicatif — Meta facture les messages WhatsApp Business directement sur votre propre compte Meta."
        },
    "sms_available": "compris dans l'abonnement",
    "sms_sent": "SMS envoyés",
    "wa_sent": "WhatsApp envoyés",
    "recalculate": "recalculer",
    "pct_sms_used": "% de SMS sont utilisés",
    "sms_info": "Prenez contact avec nous dès que 95% des SMS sont utilisés",
    "sms_warning": "Vous avez utilisé 95% ou plus de vos SMS disponible.",
    "LOW_SMS_BALANCE": "Solde SMS faible - Le SMS de secours peut échouer lorsque WhatsApp n'est pas disponible.",
    "order_sms": "Commandez maintenant de SMS en plus",
    "sms_ignore_warning": "Masquer la notification sur l’utilisation des SMS",
    "pct_plan_used": "% de vos sièges sont utilisés",
    "plan_seats_used": "capacité totale des ballons",
    "plan_valid_until": "valable jusqu’au",
    "plan_info": "Contactez-nous pour passer à un forfait supérieur si le nombre de sièges est trop faible ou pour renouveler votre abonnement actuel",
    "plan_expiring": "Votre abonnement expire bientôt. Veuillez le renouveler pour éviter toute interruption.",
    "plan_expiring_days": "Votre abonnement expire dans {days} jours. Veuillez le renouveler pour éviter toute interruption.",
    "plan_expired_grace_days": "Votre abonnement a expiré. Période de grâce se termine dans {days} jours. Veuillez renouveler immédiatement.",
    "plan_expired_since_days": "Votre abonnement a expiré il y a {days} jours. Veuillez renouveler pour continuer à utiliser Quick Release.",
    "plan_expired": "Votre abonnement a expiré et la période de grâce est terminée. Veuillez renouveler pour continuer à utiliser Quick Release.",
    "plan_invalid_grace_days": "Votre abonnement n'est pas valide - vous avez dépassé votre capacité. Période de grâce se termine dans {days} jours. Veuillez renouveler immédiatement.",
    "plan_invalid_expired": "Votre abonnement n'est pas valide - vous avez dépassé votre capacité. Période de grâce est terminée. Veuillez renouveler immédiatement pour continuer à utiliser Quick Release.",
    "manage_subscription": "Gérer l'abonnement",
    "EXPIRED_MESSAGE": "Abonnement expiré. Renouvelez-le pour continuer.",
    "blocked": "Abonnement expiré. Veuillez le renouveler pour continuer.",
    "custom_plan_title": "Plan d'abonnement personnalisé",
    "custom_plan_subtitle": "Renouvellement manuel requis",
    "custom_plan_message": "Vous avez un plan d'abonnement personnalisé.",
    "custom_plan_contact": "Veuillez contacter l'équipe Quick Release pour demander un ajustement ou un renouvellement."
  },
  "TAGS": {
    "delete": "supprimer l'drapeau",
    "enabled": "activé",
    "enable_tag": "activer l'drapeau",
    "disabled": "désactivé",
    "disable_tag": "désactiver l'drapeau",
    "save": "enregistrer l'drapeau",
    "new_tag": "créer une nouvelle drapeau",
    "tag_name": "nom du drapeau",
    "tag_type": "type du drapeau",
    "select_tag_color": "choisissez la couleur",
    "color": "couleur",
    "tag_already_added": "drapeau déjà ajouté",
    "edit": "modifier l'drapeau",
    "flight_tags": "drapeaux de vol",
    "tags": "drapeaux",
    "show_on_dashboard": "montrer sur le dashboard",
    "allowedFlightTags": "autorisés",
    "not_restricted": "tous les réservations autorisés",
    "all_flights_allowed": "tous les vols autorisés, sauf si des drapeaux de réservation spécifiques sont requis",
    "onlyAllowedFlightTags": "seulement les drapeaux de réservation suivants sont autorisés",
    "no_bookings_allowed": "aucun réservations autorisés"
  },
  "LOGBOOK": {
    "no_logbook_found": "aucun carnet de vol trouvé",
    "new_logs_since": "Nouveaux logs depuis",
    "new_logs_since_beginning": "Nouveaux logs depuis le début",
    "total_new_logs": "Nombre de nouveaux logs:",
    "total_flight_time": "Temps de vol total:",
    "add": "Ajouter",
    "log": "log",
    "logs": "logs",
    "refresh": "Actualiser",
    "logs_in_logbook": "Logs dans le carnet de vol",
    "total_logs": "Nombre de logs:",
    "latest_log": "Dernier log:",
    "export": "Exporter",
    "send_to_flightapp": "Envoyer à FlightApp",
    "delete_log": "Supprimer le log",
    "confirm_delete_log": "Supprimer ce log ?",
    "confirm_delete_log_body": "Cela supprime le log du carnet de vol. Cette action est irréversible.",
    "start_date": "Date de début",
    "initial_hours": "Heures de vol avant le carnet numérique",
    "initial_hours_hint": "Heures issues du carnet papier",
    "total_logged_time": "Temps de vol enregistré",
    "total_overall_time": "Temps de vol total",
    "settings": "Paramètres du carnet",
    "setup_logbook": "Configurer le carnet",
    "start_date_hint": "Début du carnet numérique. Les vols avant cette date relèvent du carnet papier — saisissez leurs totaux ci-dessous ; les vols à partir de cette date sont comptés depuis Quick Release. Les vols numériques plus anciens restent visibles, grisés.",
    "before_start_date": "Avant la date de début — ère papier, non comptée dans les totaux",
    "hours": "heures",
    "minutes": "Minutes",
    "save_settings": "Enregistrer",
    "settings_saved": "Paramètres du carnet enregistrés",
    "initial_flights": "Vols avant le carnet",
    "initial_flights_short": "avant",
    "total_flights": "Total des vols",
    "flights": "vols",
    "logged_short": "enregistrés",
    "stats_since": "Statistiques depuis",
    "logbook_title": "Carnet de vol",
    "up_to_date": "À jour",
    "pending_short": "à ajouter",
    "from_system_pending": "du système, pas encore ajoutés",
    "logged_flights": "Vols enregistrés"
  },
  "IMAGES": {
    "images": "images",
    "manage_images_for": "Gérer les images pour",
    "upload_new_images": "Télécharger de nouvelles images",
    "drag_and_drop_images_here": "Glissez-déposez les images ici",
    "max_files_reached": "Maximum number of images reached",
    "browse_for_images": "Parcourir les images",
    "supported_formats": "Formats supportés",
    "max_size_5mb": "taille max 5MB",
    "uploading": "Téléchargement",
    "image_library": "Bibliothèque d'images",
    "no_images_found": "Aucune image trouvée",
    "delete_image": "Supprimer l'image",
    "hint": "Les images que vous téléchargez peuvent être utilisées lors de l'envoi de messages WhatsApp"
  },
  "INVOICE": {
    "LOADING": "Chargement des factures...",
    "EMPTY_STATE": "Aucune facture trouvée des 4 dernières années",
    "TABLE": {
      "TITLE": "Factures",
      "SUBTITLE": "Aperçu de vos factures",
      "INFO": "Vous trouverez ici toutes vos factures des 4 dernières années. Cliquez sur l'icône de téléchargement pour télécharger une facture.",
      "INVOICE_CODE": "Numéro de facture",
      "AMOUNT": "Montant",
      "DATE": "Date",
      "STATUS": "Statut",
      "ACTIONS": "Actions",
      "DOWNLOAD_TOOLTIP": "Télécharger la facture"
    },
    "STATUS": {
      "PAID": "Payée",
      "SENT": "Envoyée",
      "REMINDED": "Rappelée",
      "SUMMATION": "Mise en demeure",
      "EXPIRED": "Expirée",
      "DRAFT": "Brouillon"
    }
  },
  "ORDER": {
    "LOADING": "Chargement des commandes...",
    "EMPTY_STATE": "Aucune commande trouvée des 4 dernières années",
    "TABLE": {
      "TITLE": "Commandes",
      "SUBTITLE": "Aperçu de vos commandes",
      "INFO_PENDING": "Vous pouvez ajouter des articles à une commande en attente ou la supprimer entièrement.",
      "INFO_CONFIRMED_TITLE": "Après confirmation:",
      "INFO_CONFIRMED_1": "Vous recevrez une confirmation de commande par e-mail",
      "INFO_CONFIRMED_2": "Votre commande sera traitée et approuvée",
      "INFO_CONFIRMED_3": "Vous recevrez la facture par e-mail",
      "INFO_CONFIRMED_4": "Le nouveau plan ou les crédits seront activés",
      "AMOUNT": "Montant",
      "DATE": "Date",
      "STATUS": "Statut",
      "ITEMS": "Articles",
      "PLAN": "Plan"
    },
    "STATUS": {
      "PENDING": "En attente",
      "CONFIRMED": "En traitement",
      "APPROVED": "Approuvée",
      "CANCELLED": "Annulée"
    },
    "ACTIONS": {
      "CONFIRM": "Confirmer",
      "DELETE": "Supprimer",
      "APPROVE": "Approuver",
      "CANCEL": "Annuler"
    }
  },
  "DEBTOR_VALIDATION": {
    "TITLE": "Configuration de facturation requise",
    "SUBTITLE": "Vos informations de débiteur doivent être configurées",
    "MESSAGE": "Veuillez contacter l'équipe Quick Release pour configurer vos informations de facturation et activer le renouvellement et la mise à niveau automatiques."
  },
  "NEW_ORDER": {
    "TITLE": "Nouvelle commande",
    "SUBTITLE": "Ajoutez des articles à votre commande",
    "INFO_SMS": "Commandez du crédit supplémentaire : 1 ou plusieurs forfaits de 100 SMS ou 1000 SMS.",
    "INFO_PLAN": "Calculé automatiquement en fonction de votre statut d'abonnement et de la capacité de votre ballon. Pour une mise à niveau, vous ne payez que la différence.",
    "SUBTITLE_PLAN": "Calculé automatiquement en fonction de votre statut d'abonnement et de la capacité de votre ballon. Pour une mise à niveau, vous ne payez que la différence.",
    "SUBTITLE_SMS": "Commandez du crédit supplémentaire : 1 ou plusieurs forfaits de 100 SMS ou 1000 SMS.",
    "PLAN": {
      "TITLE": "Renouvellement/Upgrade de plan",
      "EMPTY_MESSAGE": "Aucun plan disponible",
      "NAME": "Plan",
      "MAX_SEATS": "Nombre maximum de places"
    },
    "UNIT_PRICE": "Prix unitaire",
    "QUANTITY": "Quantité",
    "ORDER_QUANTITY": "Quantité",
    "TOTAL": "Total",
    "CREDIT_AUTO_ADDED": "Crédit appliqué automatiquement",
    "ALREADY_IN_ORDER": "Déjà dans la commande",
    "ADD_TO_ORDER": "Ajouter à la commande",
    "SMS": {
      "TITLE": "SMS",
      "UNIT_PRICE": "Prix par forfait",
      "PER_PACKAGE": "Par forfait",
      "ORDER_QUANTITY": "Nombre de forfaits",
      "TOTAL_SMS": "Total SMS"
    },
    "SUCCESS": "Article ajouté à la commande",
    "ERROR_LINE": "Erreur lors de l'ajout de la ligne de commande",
    "ERROR_ORDER": "Erreur lors de la création de la commande",
    "SUBMITTING": "Passage des commandes...",
    "CONFIRM_DIALOG": {
      "TITLE": "Confirmer la commande",
      "MESSAGE": "Vous êtes sur le point de passer une commande.",
      "ORDER": "Commande",
      "TOTAL": "Total",
      "VAT_EXCL": "TVA excl.",
      "VAT_21": "TVA 21%",
      "TOTAL_WITH_VAT": "Total incl. TVA",
      "VAT_REVERSE_CHARGE_NOTE": "Remarque : L'autoliquidation de la TVA peut s'appliquer à votre commande.",
      "VAT_REVERSE_CHARGE_SHORT": "(autoliquidation peut s'appliquer)",
      "NO_PAYMENT_OBLIGATION": "Une fois votre commande approuvée, vous recevrez une facture avec obligation de paiement.",
      "AGREE_TERMS": "J'accepte les",
      "TERMS_LINK": "conditions générales",
      "CONFIRM_ORDER": "Confirmer la commande"
    }
  },
  "CHECKIN": {
    "not_all_checked_in": "Tous les passagers ne se sont pas enregistrés en ligne",
    "proceed_warning": "{{count}} sur {{total}} réservations confirmées n'ont pas complété l'enregistrement en ligne. Voulez-vous continuer ?",
    "opens_on": "Enregistrement ouvre le {{date}}",
    "checked_in": "enregistré",
    "checkin_open": "Enregistrement ouvert",
    "invite_sent_at": "invitation de check-in envoyée le {{date}}",
    "invite_not_sent": "aucune invitation de check-in envoyée",
    "send_invite": "envoyer l'invitation de check-in",
    "invite_sent_success": "invitation de check-in envoyée",
    "send_invite_all": "envoyer l'invitation de check-in à toutes les réservations ouvertes",
    "send_invite_all_confirm": "Envoyer l'invitation de check-in à {{count}} réservations ?",
    "invites_status_sent": "{{count}} invitation(s) envoyée(s)",
    "invites_status_planned": "{{count}} planifiée(s) le {{date}}",
    "invite_planned_on": "invitation de check-in planifiée le {{date}}",
    "send_now": "envoyer maintenant",
    "preview_subject": "Votre vol est prêt pour l'enregistrement – {{date}} – {{location}}",
    "preview_greeting": "Cher/Chère {{name}},",
    "preview_body": "Votre vol en montgolfière du <strong>{{date}}</strong> est maintenant ouvert à l'enregistrement en ligne.",
    "preview_body2": "Veuillez compléter l'enregistrement pour votre groupe ({{count}} passagers) avant la date du vol. Lors de l'enregistrement, il vous sera demandé de lire et confirmer les consignes de sécurité.",
    "preview_cta": "S'enregistrer maintenant",
    "preview_footer": "Si vous avez des questions, n'hésitez pas à nous contacter.",
    "preview_wa_body": "Votre vol en montgolfière du **{{date}}** est maintenant ouvert à l'enregistrement en ligne.",
    "preview_wa_body2": "Veuillez compléter l'enregistrement pour votre groupe ({{count}} passagers) avant la date du vol.",
    "preview_wa_link": "Accédez directement à votre page de réservation personnelle via ce lien!",
    "signature_sheet": "feuille de signatures du check-in",
    "acknowledge": "J'ai lu et compris les informations ci-dessus",
    "pdf_check_in": "CHECK-IN",
    "pdf_passenger_manifest": "Liste des passagers",
    "pdf_safety_briefing": "Briefing de sécurité",
    "pdf_please_read": "À lire avant l'embarquement",
    "pdf_balloon_operator": "Opérateur de montgolfière",
    "pdf_acknowledgement": "ATTESTATION",
    "pdf_passenger": "Passager",
    "pdf_signature": "Signature",
    "pdf_morning_flight": "Vol du matin",
    "pdf_evening_flight": "Vol du soir",
    "pdf_date": "DATE",
    "pdf_balloon": "BALLON",
    "pdf_pic": "COMMANDANT DE BORD",
    "pdf_takeoff": "DÉCOLLAGE",
    "pdf_pic_on_file": "Signature CDB enregistrée",
    "pdf_local_time": "Heure locale",
    "pdf_page": "Page {{current}} sur {{total}}",
    "pdf_manifest_subtitle": "{{pax}} passagers · {{bookings}} réservations"
  },
  "NOTAM": {
    "title": "NOTAM",
    "panel_title_combined": "météo et NOTAM",
    "tooltip_count": "{{count}} NOTAM — ouvrir le vol pour les détails",
    "none_known": "aucun NOTAM pertinent connu",
    "none_known_short": "aucun NOTAM connu",
    "no_data": "pas de données NOTAM pour ce site",
    "stale": "les données NOTAM n'ont pas pu être actualisées — dernière mise à jour {{time}}",
    "unavailable": "données NOTAM indisponibles",
    "retry": "réessayer",
    "updated": "données NOTAM mises à jour {{time}}",
    "disclaimer": "Aide à la décision uniquement — l'obligation officielle de briefing avant le vol reste au commandant de bord (PIC).",
    "horizon_hint": "les NOTAM sont généralement publiés peu avant la date, revérifiez à l'approche du vol",
    "wide_area": "avis de fond (zone étendue / AIP)",
    "show_text": "afficher le texte NOTAM original",
    "hide_text": "masquer le texte NOTAM original",
    "period": "période active",
    "schedule": "horaire journalier",
    "altitude_band": "tranche d'altitude",
    "connect_hint": "connectez votre compte Autorouter pour voir les alertes NOTAM",
    "reconnect_hint": "reconnectez votre compte Autorouter pour actualiser les alertes NOTAM",
    "connect_link": "ouvrir les paramètres",
    "location_warning": "{{count}} NOTAM sur ce site pour le créneau du vol",
    "CATEGORY": {
      "RESTRICTION": "restriction d'espace aérien",
      "WARNING": "avertissement à la navigation",
      "OBSTACLE": "obstacle",
      "AERODROME": "aérodrome",
      "UNCLASSIFIED": "non classé"
    },
    "SETTINGS": {
      "title": "Espace aérien / NOTAM",
      "explanation": "Les alertes NOTAM sur les vols, la carte de trajectoire et le tableau de bord nécessitent votre propre compte (gratuit) autorouter.aero. Quick Release récupère les données NOTAM sous l'autorisation de votre compte.",
      "disclaimer": "Les alertes NOTAM sont une aide à la décision ; l'obligation officielle de briefing avant le vol reste au commandant de bord (PIC).",
      "connect": "connecter le compte Autorouter",
      "reconnect": "reconnecter le compte Autorouter",
      "disconnect": "déconnecter",
      "disconnect_confirm": "Déconnecter votre compte Autorouter ? L'autorisation enregistrée et les données NOTAM récupérées seront supprimées.",
      "connected_as": "connecté en tant que",
      "connected_since": "depuis",
      "status_disconnected": "aucun compte Autorouter connecté",
      "reauth_warning": "l'autorisation Autorouter a expiré ou a été révoquée — reconnectez-vous pour continuer à recevoir les données NOTAM",
      "connected_snack": "compte Autorouter connecté",
      "denied_snack": "connexion Autorouter refusée",
      "error_snack": "échec de la connexion Autorouter — réessayez"
    }
  },
  "WEEKPLANNER": {
    "matrix": {
      "availability": "disponibilité",
      "availability_tooltip": "Nombre de pilotes et d’équipiers disponibles — survolez les points pour les noms",
      "availability_empty": "Pas encore de gestion des disponibilités. Laissez pilotes et équipiers saisir eux-mêmes leurs disponibilités et vous verrez ici qui peut voler chaque jour.",
      "start_crew_login": "Commencer avec la connexion équipage",
      "pilots_available": "pilotes disponibles",
      "crew_available": "équipiers disponibles",
      "open_balloon": "Ouvrir le détail du ballon",
      "seats": "places",
      "add_balloon": "Ajouter un ballon",
      "no_balloons": "Pas encore de ballons. Ajoutez votre premier ballon pour planifier des vols.",
      "no_flights": "Aucun vol cette semaine.",
      "show_idle_balloons": "Ballons sans vol ({{count}})",
      "hide_idle_balloons": "Masquer les ballons sans vol",
      "add_flight_for": "Ajouter un vol —",
      "open_flight_tooltip": "Ouvrir le détail du vol (ou Ctrl/Cmd-clic sur la cellule)",
      "fly_ok": "Volable",
      "fly_wind": "Alerte vent",
      "fly_rain": "Non volable — précipitations",
      "fly_nogo_wind": "Non volable — vent"
    },
    "availability": {
      "yes": "disponible",
      "maybe": "peut-être",
      "no": "pas disponible",
      "unknown": "non renseigné"
    },
    "create": {
      "new_location_option": "+ Nouveau site…",
      "no_locations": "Vous n'avez pas encore de sites de décollage. Créez le premier.",
      "new_location": "Nouveau site",
      "new_location_placeholder": "p. ex. Bruges – Minnewater",
      "new_location_note": "GPS, autorisation et contact se complètent plus tard dans le détail du site.",
      "save_location": "Enregistrer le site",
      "location_created": "Site {{name}} créé.",
      "location_created_default": "Site {{name}} créé — aussi votre site par défaut pour la météo et le soleil."
    },
    "planner": {
      "available_drag": "disponible — glissez sur un vol",
      "no_people": "pas encore de pilotes ni d'équipiers",
      "assign_to": "Affecter à…",
      "add_pilot": "Pilote",
      "add_crew": "Équipier",
      "edit": "Modifier les infos du vol",
      "edit_done": "Modification terminée",
      "publish": "Publier pour l'équipage",
      "unpublish": "Masquer pour l'équipage",
      "mark_finished": "Marquer comme effectué",
      "cancel": "Annuler le vol",
      "restore": "Rétablir le vol",
      "staffing": "Pilote, chauffeur BE et équipage",
      "published_chip": "équipage",
      "published_tooltip": "Visible pour l'équipage",
      "pilot": "Pilote",
      "driver": "Chauffeur BE",
      "crew": "Équipage",
      "takeoff_temperature": "Température au décollage",
      "trajectory": "trajectoire",
      "lift_free": "{{kg}} kg libres",
      "capacity_warning_title": "Cela dépasse la capacité du ballon",
      "capacity_warning_body": "{{total}} passagers pour {{capacity}} places. Continuer quand même ?",
      "lift_warning_title": "Portance faible sur ce vol",
      "lift_warning_body": "Plus que {{lift}} kg de portance libre. Affecter quand même ?",
      "person_already_assigned": "{{name}} est déjà sur {{flight}} dans ce créneau.",
      "cancel_on_flight_page": "Ce vol a des réservations confirmées : annulez-le sur la page du vol pour prévenir les passagers.",
      "preferred_of": "équipe habituelle de {{balloons}}",
      "propose_crew": "Proposer l’équipe habituelle",
      "propose_tooltip": "Mettre {{names}} sur le vol de {{balloon}}",
      "apply_all": "Tout appliquer"
    },
    "toast": {
      "flight_updated": "Vol mis à jour — données de la semaine rechargées.",
      "booking_confirmed": "Réservation confirmée — e-mail de confirmation envoyé.",
      "balloon_updated": "Ballon mis à jour.",
      "save_failed": "Échec de l’enregistrement — réessayez."
    },
    "pool": {
      "oldest_first": "plus anciennes d’abord",
      "clear_search": "effacer",
      "new_booking": "Nouvelle réservation",
      "filters": "filtres",
      "count_tooltip": "nombre dans la recherche actuelle",
      "chip_to_confirm": "à confirmer",
      "chip_unplanned": "non planifiée",
      "chip_voucher": "bon expirant",
      "chip_open_amount": "montant dû",
      "chip_favourite": "favori",
      "clear_filters": "effacer les filtres",
      "col_name": "Nom",
      "col_contact": "Contact",
      "col_pax": "Pers. · poids",
      "col_info": "Info",
      "col_comment": "Remarque",
      "col_flight": "Vol",
      "col_actions": "Actions",
      "no_match": "Aucune réservation pour ces filtres.",
      "flight_tooltip": "Ouvrir le vol — glisser déplace la réservation",
      "unplanned": "non planifiée",
      "confirm": "Confirmer",
      "load_more_n": "Charger plus ({{n}})"
    },
    "panel": {
      "kind_flight": "Vol",
      "kind_balloon": "Ballon",
      "kind_booking": "Réservation",
      "kind_person": "Personne",
      "kind_location": "Site",
      "back": "Retour au planning de la semaine",
      "close": "Fermer",
      "not_found": "Introuvable — peut-être supprimé.",
      "balloon": "Ballon",
      "status": "Statut",
      "status_SCH": "planifié",
      "status_REA": "prêt au départ",
      "status_FIN": "effectué",
      "status_CAN": "annulé",
      "sun": "Soleil",
      "sunrise": "lever du soleil",
      "sunset": "coucher du soleil",
      "yes": "oui",
      "no": "non",
      "crew_section": "Équipage",
      "bookings": "Réservations",
      "no_bookings_on_flight": "Pas encore de réservations sur ce vol.",
      "heading": "Direction prévue",
      "distance": "Distance",
      "landing_zone": "Zone d’atterrissage",
      "logbook": "Carnet de vol",
      "takeoff_time": "Heure de décollage",
      "landing_time": "Heure d’atterrissage",
      "landing_place": "Lieu d’atterrissage",
      "fuel": "Consommation (bouteilles)",
      "open_page": "Ouvrir la page complète",
      "passenger_seats": "places passagers",
      "passenger_seats_label": "Places passagers",
      "basics": "Base",
      "registration": "Immatriculation",
      "to_complete": "à compléter",
      "envelope": "Enveloppe",
      "envelope_manufacturer": "Fabricant",
      "envelope_volume": "Volume (m³)",
      "envelope_type": "Type",
      "basket_burner": "Nacelle & brûleur",
      "basket_type": "Type de nacelle",
      "burner_type": "Brûleur",
      "cylinders": "Nombre de bouteilles",
      "insurance": "Assurance",
      "insurance_company": "Compagnie",
      "due_date": "Échéance",
      "maintenance": "Entretien",
      "last_inspection": "Dernière inspection",
      "envelope_hours": "Heures de vol enveloppe",
      "flights_this_week": "Vols cette semaine",
      "no_flights": "Aucun vol planifié.",
      "booking_detail": "Détail de la réservation",
      "contact": "Contact",
      "phone": "Téléphone",
      "email": "E-mail",
      "city": "Commune",
      "passengers": "Passagers",
      "preferred": "Souhaité",
      "not_chosen": "pas encore choisi",
      "not_planned": "Non planifié.",
      "booking_status_OPEN": "ouverte",
      "booking_status_ADDE": "ajoutée — à confirmer",
      "booking_status_INVI": "invitée",
      "booking_status_CONF": "confirmée",
      "booking_status_COMP": "terminée",
      "booking_status_CANC": "annulée",
      "region": "Région",
      "payment": "Paiement",
      "to_pay": "À payer",
      "paid": "Payé",
      "voucher": "Bon cadeau",
      "booking_code": "Code",
      "valid_until": "Valable jusqu’au",
      "passenger_n": "Passager {{n}}",
      "open_flight": "Ouvrir le vol",
      "availability_this_week": "Disponibilité cette semaine",
      "profile": "Profil",
      "license_number": "Numéro de licence",
      "license_expiry": "Licence valable jusqu’au",
      "medical_until": "Visite médicale jusqu’au",
      "driver_licence_be": "Permis BE",
      "launch_site": "Site de décollage",
      "default_for_weather": "site par défaut pour la météo et le soleil",
      "default_location": "Site par défaut",
      "no_flights_location": "Aucun vol depuis ce site.",
      "location_detail": "Détail du site",
      "gps": "Coordonnées GPS",
      "address": "Adresse",
      "contact_person": "Personne de contact",
      "access_parking": "Accès & parking",
      "preferred_crew": "Équipe habituelle",
      "preferred_crew_note": "Sur la base des affectations précédentes.",
      "preferred_crew_of": "Équipe habituelle de",
      "no_preferred_balloon": "Pas encore de ballon habituel — découle des affectations."
    },
    "meteo": {
      "title": "Météo",
      "no_default_location": "pas de site par défaut",
      "follows_selection": "suit le jour sélectionné",
      "today_hint": "aujourd’hui — sélectionnez un jour dans la matrice",
      "sun": "soleil {{rise}} – {{set}}",
      "pill_good": "volable",
      "pill_marginal": "incertain",
      "pill_nogo": "non volable",
      "pill_unknown": "pas de prévision",
      "pill_tooltip_good": "Volable — vent dans les limites",
      "pill_tooltip_marginal": "Incertain — rafales au-dessus de la limite",
      "pill_tooltip_nogo": "Non volable — précipitations ou vent hors limites",
      "pill_tooltip_unknown": "Pas de prévision pour ce créneau",
      "no_forecast": "pas de prévision pour ce jour",
      "row_hour": "Heure",
      "row_weather": "Temps",
      "row_temp": "Temp (°C)",
      "row_ground": "Sol",
      "row_wind": "Vent (kn)",
      "row_gust": "Rafales (kn)",
      "row_pressure": "Pression (hPa)",
      "row_clouds": "Nuages",
      "row_visibility": "Visibilité (km)",
      "legend": "heures dorées — créneaux de vol autour du lever ({{rise}}) et du coucher du soleil ({{set}}) · barbules : pleine = 10 kn, demie = 5 kn",
      "updated": "mis à jour"
    },
    "myWeek": {
      "title": "Ma semaine — {{name}}",
      "hint": "disponibilité : cliquez pour changer · glissez sur d’autres jours pour copier",
      "my_availability": "ma disponibilité",
      "flights": "Vols",
      "click_to_fill": "cliquez pour remplir",
      "own_pilot": "Mon vol — je pilote",
      "own_crew": "Mon vol — je suis l’équipe au sol",
      "published": "Vol publié",
      "join": "Je viens",
      "saved": "Disponibilité enregistrée — le planificateur la voit tout de suite.",
      "cleared": "Disponibilité effacée.",
      "error_FLIGHT_HAS_CREW": "Quelqu’un d’autre vient déjà sur ce vol.",
      "error_FLIGHT_NOT_PUBLISHED": "Ce vol n’est plus publié.",
      "error_FLIGHT_NOT_SCHEDULED": "Ce vol n’est plus planifié.",
      "error_NOT_ON_FLIGHT": "Vous n’êtes plus sur ce vol.",
      "error_ALREADY_PILOT": "Vous êtes déjà pilote de ce vol."
    },
    "theme": {
      "title": "Thème",
      "light": "Clair",
      "dark": "Sombre",
      "system": "Système"
    }
  }
}
